(() => {
  const initialized = new WeakSet();

  const initConfigurator = (configuratorRoot) => {
    if (!(configuratorRoot instanceof HTMLElement)) return;
    if (initialized.has(configuratorRoot)) return;
    initialized.add(configuratorRoot);

    try {

    const dataScript = configuratorRoot.querySelector('script[data-configurator="product"]');
    if (!dataScript) return;

    let config;
    try {
      config = JSON.parse(dataScript.textContent || '{}');
    } catch {
      config = {};
    }

    const jrIsDebug = () => {
      try {
        return new URL(window.location.href).searchParams.get('jr_debug') === '1';
      } catch {
        return false;
      }
    };

    const scopeRoot =
      configuratorRoot.closest('quick-add-modal') ||
      configuratorRoot.closest('product-info') ||
      document;

    const productForm =
      scopeRoot.querySelector('product-form form[action*="/cart/add"]') ||
      scopeRoot.querySelector('form[action*="/cart/add"]') ||
      scopeRoot.querySelector('form[action*="cart/add"]');

    if (!productForm) {
      const errorsEl = configuratorRoot.querySelector('[data-jr-configurator-errors]');
      if (errorsEl) {
        errorsEl.hidden = false;
        errorsEl.textContent = 'Configurator could not find the product form on this page.';
      }
      return;
    }

    const isQuickAdd = Boolean(configuratorRoot.closest('quick-add-modal'));

    // Move configurator into the product info rail to feel native (Koala-style layout).
    // Skip this when running inside Quick Add because the modal already injects it in the right place.
    if (!isQuickAdd) {
      try {
        const originalSection = configuratorRoot.closest('section');
        const productInfo =
          document.querySelector(`product-info[data-product-id="${String(config.productId || '')}"]`) ||
          document.querySelector('product-info');
        const infoContainer = productInfo
          ? productInfo.querySelector('.product__info-container')
          : document.querySelector('.product__info-container');

        if (infoContainer instanceof HTMLElement) {
          const priceOrStartingFromBlock =
            infoContainer.querySelector('[data-jr-starting-price-container]') || infoContainer.querySelector('[id^="price-"]');
          const titleBlock = infoContainer.querySelector('.product__title');
          if (priceOrStartingFromBlock && priceOrStartingFromBlock.parentElement === infoContainer) {
            priceOrStartingFromBlock.insertAdjacentElement('afterend', configuratorRoot);
          } else if (titleBlock && titleBlock.parentElement === infoContainer) {
            titleBlock.insertAdjacentElement('afterend', configuratorRoot);
          } else {
            infoContainer.insertAdjacentElement('afterbegin', configuratorRoot);
          }
          configuratorRoot.classList.add('jr-configurator--in-product');
          if (originalSection && originalSection instanceof HTMLElement) {
            originalSection.style.display = 'none';
          }
        }
      } catch {
        // ignore
      }
    } else {
      configuratorRoot.classList.add('jr-configurator--in-product');
    }

    const missing = [];
    if (!config || typeof config !== 'object') missing.push('config');
    if (!config.pricing) missing.push('pricing');
    if (!Array.isArray(config.sizes) || config.sizes.length === 0) missing.push('sizes');
    if (!Array.isArray(config.materials) || config.materials.length === 0) missing.push('materials');
    if ((!Array.isArray(config.colours) || config.colours.length === 0) && (!Array.isArray(config.finishes) || config.finishes.length === 0))
      missing.push('colours');
    if (missing.length > 0) {
      const errorsEl = configuratorRoot.querySelector('[data-jr-configurator-errors]');
      if (errorsEl) {
        errorsEl.hidden = false;
        errorsEl.innerHTML = `<p><strong>Configurator setup incomplete.</strong> Missing: ${missing
          .map((m) => `<code>${m}</code>`)
          .join(', ')}. Re-run the product metafield seed for this handle.</p>`;
      }
    }

  const getField = (key) => configuratorRoot.querySelector(`[data-jr-config-field="${key}"]`);
  const sizeField = getField('size');
  const customWidthField = getField('customWidthMm');
  const customHeightField = getField('customHeightMm');
  const customDepthField = getField('customDepthMm');
  const drawersField = getField('drawers');
  const materialField = getField('material');
  const finishTypeField = getField('finishType');
  const colourFieldWrapper = configuratorRoot.querySelector('[data-jr-config-colour-field]');
  const getColourSelects = () =>
    Array.from(configuratorRoot.querySelectorAll('select[data-jr-config-colour-slot]')).filter(
      (el) => el instanceof HTMLSelectElement && !el.disabled
    );
  const getFinishSelects = () =>
    Array.from(configuratorRoot.querySelectorAll('select[data-jr-config-finish-slot]')).filter(
      (el) => el instanceof HTMLSelectElement && !el.disabled
    );
  const getTwoToneInputs = () =>
    Array.from(configuratorRoot.querySelectorAll('input[data-jr-config-field="twoTone"]')).filter((el) => el instanceof HTMLInputElement);
  const depthField = getField('depth');
  const shelvesField = getField('shelves');
  const getAdjustableShelvesInputs = () =>
    Array.from(configuratorRoot.querySelectorAll('input[data-jr-config-field="adjustableShelves"]')).filter(
      (x) => x instanceof HTMLInputElement
    );
  const notesField = getField('notes');
  const errorsEl = configuratorRoot.querySelector('[data-jr-configurator-errors]');
  const priceEl = configuratorRoot.querySelector('[data-jr-configurator-price]');
  const priceNoteEl = configuratorRoot.querySelector('[data-jr-configurator-price-note]');
  const customSizeWrappers = configuratorRoot.querySelectorAll('[data-jr-config-custom-size-field]');
  const depthFieldWrapper = configuratorRoot.querySelector('[data-jr-config-depth-field]');
  const customDepthWrapper = configuratorRoot.querySelector('[data-jr-config-custom-depth-field]');
  const drawersMaxEl = configuratorRoot.querySelector('[data-jr-config-drawers-max]');
  const shelvesMaxEl = configuratorRoot.querySelector('[data-jr-config-shelves-max]');
  const leadTimeEl = configuratorRoot.querySelector('[data-jr-configurator-lead-time]');
  const adjustableAddonEl = configuratorRoot.querySelector('[data-jr-config-adjustable-addon]');
  const dialogEl = configuratorRoot.querySelector('[data-jr-configurator-dialog]');
  const dialogTitleEl = configuratorRoot.querySelector('[data-jr-dialog-title]');
  const dialogBodyEl = configuratorRoot.querySelector('[data-jr-dialog-body]');
  const dialogCloseBtn = configuratorRoot.querySelector('[data-jr-dialog-close]');
  const oversizeCallRow = configuratorRoot.querySelector('[data-jr-oversize-call]');
  const oversizeCallTextEl = configuratorRoot.querySelector('[data-jr-oversize-call-text]');
  const customConstraintsEl = configuratorRoot.querySelector('[data-jr-config-custom-constraints]');

  const sizeStandardTilesEl = configuratorRoot.querySelector('[data-jr-option-tiles="size-standard"]');
  const sizeCustomTilesEl = configuratorRoot.querySelector('[data-jr-option-tiles="size-custom"]');
  const materialTilesEl = configuratorRoot.querySelector('[data-jr-option-tiles="material"]');
  const finishTilesEl = configuratorRoot.querySelector('[data-jr-option-tiles="finishType"]');

  const stepsContainer = configuratorRoot.querySelector('[data-jr-config-steps]');
  const stepperPriceEl = configuratorRoot.querySelector('[data-jr-stepper-price]');
  const stepperPriceValueEl = configuratorRoot.querySelector('[data-jr-stepper-price-value]');
  const stepperLeadTimeEl = configuratorRoot.querySelector('[data-jr-stepper-lead-time]');
  const startingPriceEl = scopeRoot.querySelector('[data-jr-starting-price]');

  const stickyCtaEl = configuratorRoot.querySelector('[data-jr-sticky-cta]');
  const stickyPriceEl = configuratorRoot.querySelector('[data-jr-sticky-price]');
  const stickySelectionEl = configuratorRoot.querySelector('[data-jr-sticky-selection]');
  const stickyAddBtn = configuratorRoot.querySelector('[data-jr-sticky-add]');
  const stickyAddBtnLabelEl = stickyAddBtn ? stickyAddBtn.querySelector('[data-jr-sticky-btn-label]') : null;
  const stickyAddBtnPriceEl = stickyAddBtn ? stickyAddBtn.querySelector('[data-jr-sticky-btn-price]') : null;
  const qtyRowEl = configuratorRoot.querySelector('[data-jr-qty-row]');
  const qtySlotEl = configuratorRoot.querySelector('[data-jr-qty-slot]');

  let stickyAllowedByScroll = false;

    // Ensure the sticky CTA is fixed to the viewport (some transformed containers can "trap" position: fixed).
    // Skip this inside Quick Add modals (use the in-modal estimate pill instead).
    try {
      if (!isQuickAdd && stickyCtaEl instanceof HTMLElement && !stickyCtaEl.hasAttribute('data-jr-sticky-portal')) {
        stickyCtaEl.setAttribute('data-jr-sticky-portal', '1');
        document.body.appendChild(stickyCtaEl);
      }
    } catch {
      // ignore
    }

    // Port the PDP quantity UI into the configurator panel (AMC products).
    // Keep this out of Quick Add to avoid breaking the modal flow.
    try {
      if (
        !isQuickAdd &&
        qtySlotEl instanceof HTMLElement &&
        !qtySlotEl.hasAttribute('data-jr-qty-ported') &&
        !qtySlotEl.closest('quick-add-modal')
      ) {
        const productInfoEl =
          document.querySelector(`product-info[data-product-id="${String(config.productId || '')}"]`) ||
          document.querySelector('product-info');
        const quantityFormEl =
          (productInfoEl ? productInfoEl.querySelector('.product-form__quantity') : null) ||
          document.querySelector('.product-form__quantity');

        if (quantityFormEl instanceof HTMLElement) {
          if (quantityFormEl.closest('[data-jr-qty-slot]') !== qtySlotEl) {
            qtySlotEl.appendChild(quantityFormEl);
          }
          if (qtyRowEl instanceof HTMLElement) qtyRowEl.hidden = false;
          qtySlotEl.setAttribute('data-jr-qty-ported', '1');
          quantityFormEl.setAttribute('data-jr-qty-ported', '1');
        }
      }
    } catch {
      // ignore
    }

    const escapeAttrValue = (value) => String(value).replaceAll('"', '\\"');
    const escapeHtml = (text) =>
      String(text).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');
    const escapeAttr = (text) => escapeHtml(text).replaceAll('"', '&quot;').replaceAll("'", '&#39;');

    const ensureHiddenInput = (name) => {
      // Avoid CSS.escape dependency (older browsers / locked-down environments).
      let input = productForm.querySelector(`input[type="hidden"][name="${escapeAttrValue(name)}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        productForm.appendChild(input);
      }
      return input;
    };

  const setProperty = (key, value) => {
    const input = ensureHiddenInput(`properties[${key}]`);
    input.value = value == null ? '' : String(value);
  };

  const getSelectedText = (selectEl) => {
    if (!selectEl) return '';
    const selectedOption = selectEl.options[selectEl.selectedIndex];
    return selectedOption ? selectedOption.textContent.trim() : '';
  };

  const buildState = () => {
    const twoToneInputs = getTwoToneInputs();
    let twoTone = false;
    if (twoToneInputs.length > 0) {
      const selected = twoToneInputs.find((i) => i.checked);
      twoTone = selected ? String(selected.value || '') === 'yes' : false;
    } else {
      twoTone = Boolean(config && config.defaultTwoTone);
    }

    const finishSelects = getFinishSelects();
    const finishesBySlot = {};
    finishSelects.forEach((select) => {
      if (!(select instanceof HTMLSelectElement)) return;
      if (select.dataset.jrTwoToneSlot === 'base' && !twoTone) return;
      const slot = String(select.dataset.jrConfigFinishSlot || 'main');
      const selectedOption = select.options[select.selectedIndex];
      finishesBySlot[slot] = {
        code: select.value || '',
        label: selectedOption ? String(selectedOption.textContent || '').trim() : '',
      };
    });

    const colourSelects = getColourSelects();
    const coloursBySlot = {};
    colourSelects.forEach((select) => {
      if (!(select instanceof HTMLSelectElement)) return;
      if (select.dataset.jrTwoToneSlot === 'base' && !twoTone) return;
      const slot = String(select.dataset.jrConfigColourSlot || 'main');
      const selectedOption = select.options[select.selectedIndex];
      coloursBySlot[slot] = {
        code: select.value || '',
        label: selectedOption ? String(selectedOption.textContent || '').trim() : '',
      };
    });

    const globalFinishCode = finishTypeField ? String(finishTypeField.value || '') : '';
    const globalFinishLabel = getSelectedText(finishTypeField);
    const mainFinish =
      finishesBySlot.main && typeof finishesBySlot.main === 'object'
        ? finishesBySlot.main
        : {
            code: globalFinishCode,
            label: globalFinishLabel,
          };

    const adjustableInputs = getAdjustableShelvesInputs();
    let adjustableShelves = false;
    if (adjustableInputs.length > 0) {
      const anyRadio = adjustableInputs.some((i) => i.type === 'radio');
      if (anyRadio) {
        const selected = adjustableInputs.find((i) => i.type === 'radio' && i.checked);
        adjustableShelves = selected ? String(selected.value || '') === 'yes' : false;
      } else {
        adjustableShelves = adjustableInputs[0].checked;
      }
    }

    const state = {
      sizeCode: sizeField ? sizeField.value : '',
      sizeLabel: getSelectedText(sizeField),
      customWidthMm: customWidthField ? customWidthField.value : '',
      customHeightMm: customHeightField ? customHeightField.value : '',
      customDepthMm: customDepthField ? customDepthField.value : '',
      materialCode: materialField ? materialField.value : '',
      materialLabel: getSelectedText(materialField),
      finishTypes: finishesBySlot,
      finishTypeCode: String(mainFinish.code || ''),
      finishTypeLabel: String(mainFinish.label || ''),
      colours: coloursBySlot,
      colourCode: coloursBySlot.main ? coloursBySlot.main.code : '',
      colourLabel: coloursBySlot.main ? coloursBySlot.main.label : '',
      depthCode: depthField ? depthField.value : '',
      depthLabel: getSelectedText(depthField),
      drawers: drawersField ? String(drawersField.value || '').trim() : '',
      shelves: shelvesField ? shelvesField.value : '0',
      adjustableShelves,
      notes: notesField ? notesField.value : '',
      difficultyTier: String(config.difficultyTier || '1'),
      difficultyMultiplier: String(config.difficultyMultiplier || ''),
      twoTone,
    };

    // If this product supports slots like top/base but the customer selected "No" for two-tone,
    // treat base as the same as top (cleaner ops data, fewer questions for the customer).
    try {
      const isMultiSlot = config && config.colourSlotMode ? String(config.colourSlotMode) === 'multi' : false;
      if (isMultiSlot && !state.twoTone) {
        if (state.finishTypes && state.finishTypes.top && !state.finishTypes.base) {
          state.finishTypes.base = state.finishTypes.top;
        }
        if (state.colours && state.colours.top && !state.colours.base) {
          state.colours.base = state.colours.top;
        }
      }
    } catch {
      // ignore
    }
    return state;
  };

  const isCustomSize = (state) => state.sizeCode === '__custom__';

  const getSteps = () => {
    if (!(stepsContainer instanceof HTMLElement)) return [];
    return Array.from(stepsContainer.querySelectorAll('details[data-jr-step]')).filter((x) => x instanceof HTMLDetailsElement);
  };

  const isStepVisible = (detailsEl) => {
    if (!(detailsEl instanceof HTMLElement)) return false;
    if (detailsEl.hidden) return false;
    if (detailsEl.closest('[hidden]')) return false;
    return true;
  };

  const isStepComplete = (detailsEl) => {
    if (!(detailsEl instanceof HTMLElement)) return true;
    const requiredEls = Array.from(
      detailsEl.querySelectorAll('[data-required], select[required], input[required], textarea[required]')
    ).filter((el) => el instanceof HTMLElement);

    if (requiredEls.length === 0) return true;

    return requiredEls.every((el) => {
      if (el instanceof HTMLSelectElement) return String(el.value || '').trim() !== '';
      if (el instanceof HTMLTextAreaElement) return !el.required || String(el.value || '').trim() !== '';
      if (el instanceof HTMLInputElement) {
        if (!el.required) return true;
        if (el.type === 'checkbox') return Boolean(el.checked);
        return String(el.value || '').trim() !== '';
      }
      return true;
    });
  };

  const closeOtherSteps = (openEl) => {
    getSteps().forEach((step) => {
      if (step !== openEl) step.open = false;
    });
  };

  const isBookcaseProduct = (pricing) => {
    const category = pricing && pricing.category ? String(pricing.category) : '';
    const tagHint = config && (config.presetKey || config.amcTag) ? String(config.presetKey || config.amcTag) : '';
    return /bookcase/i.test(category) || /bookcase/i.test(tagHint);
  };

  const isBedsideProduct = (pricing) => {
    const category = pricing && pricing.category ? String(pricing.category) : '';
    const tagHint = config && (config.presetKey || config.amcTag) ? String(config.presetKey || config.amcTag) : '';
    return /bedside/i.test(category) || /bedside/i.test(tagHint);
  };

  const getCustomConstraints = (pricing) => {
    const rawCandidate =
      pricing && typeof pricing === 'object'
        ? pricing.custom_constraints && typeof pricing.custom_constraints === 'object'
          ? pricing.custom_constraints
          : pricing.customConstraints && typeof pricing.customConstraints === 'object'
            ? pricing.customConstraints
            : null
        : null;

    const raw = rawCandidate && typeof rawCandidate === 'object' ? rawCandidate : null;
    if (raw) {
      const toNum = (v) => {
        const n = Number(v);
        return Number.isFinite(n) && n > 0 ? n : null;
      };
      return {
        minWidthMm: toNum(raw.min_width_mm),
        maxWidthMm: toNum(raw.max_width_mm),
        minHeightMm: toNum(raw.min_height_mm),
        maxHeightMm: toNum(raw.max_height_mm),
        minDepthMm: toNum(raw.min_depth_mm),
        maxDepthMm: toNum(raw.max_depth_mm),
      };
    }

    if (isBookcaseProduct(pricing)) {
      return {
        minWidthMm: 300,
        maxHeightMm: 2400,
        minDepthMm: 250,
        maxDepthMm: 600,
      };
    }

    if (isBedsideProduct(pricing)) {
      return {
        minWidthMm: 400,
        maxWidthMm: 800,
        minHeightMm: 400,
        maxHeightMm: 800,
        minDepthMm: 350,
        maxDepthMm: 600,
      };
    }

    return null;
  };

  const getConstraintIssuesForState = (state, pricing) => {
    const constraints = getCustomConstraints(pricing);
    if (!constraints) return null;
    if (!isCustomSize(state)) return null;

    const widthMm = Number(state.customWidthMm);
    const heightMm = Number(state.customHeightMm);
    const depthMm = Number(state.customDepthMm);

    const issues = [];

    if (Number.isFinite(widthMm) && widthMm > 0) {
      if (Number.isFinite(constraints.minWidthMm) && widthMm < constraints.minWidthMm) {
        issues.push({ kind: 'undersize', msg: `Min width is ${constraints.minWidthMm}mm` });
      }
      if (Number.isFinite(constraints.maxWidthMm) && widthMm > constraints.maxWidthMm) {
        issues.push({ kind: 'oversize', msg: `Max width is ${constraints.maxWidthMm}mm` });
      }
    }
    if (Number.isFinite(heightMm) && heightMm > 0) {
      if (Number.isFinite(constraints.minHeightMm) && heightMm < constraints.minHeightMm) {
        issues.push({ kind: 'undersize', msg: `Min height is ${constraints.minHeightMm}mm` });
      }
      if (Number.isFinite(constraints.maxHeightMm) && heightMm > constraints.maxHeightMm) {
        issues.push({ kind: 'oversize', msg: `Max height is ${constraints.maxHeightMm}mm` });
      }
    }
    if (Number.isFinite(depthMm) && depthMm > 0) {
      if (Number.isFinite(constraints.minDepthMm) && depthMm < constraints.minDepthMm) {
        issues.push({ kind: 'undersize', msg: `Min depth is ${constraints.minDepthMm}mm` });
      }
      if (Number.isFinite(constraints.maxDepthMm) && depthMm > constraints.maxDepthMm) {
        issues.push({ kind: 'oversize', msg: `Max depth is ${constraints.maxDepthMm}mm` });
      }
    }

    if (issues.length === 0) return null;
    return { constraints, issues };
  };

  const getModularSplitForWidth = (widthMm, pricing) => {
    const category = pricing && pricing.category ? String(pricing.category) : '';
    const tagHint = config && (config.presetKey || config.amcTag) ? String(config.presetKey || config.amcTag) : '';
    const isBookcase = /bookcase/i.test(category) || /bookcase/i.test(tagHint);
    const modular = pricing && typeof pricing.modular_units === 'object' && pricing.modular_units ? pricing.modular_units : null;
    const enabled = modular ? modular.enabled !== false : isBookcase;
    const buildUnitWidths = (totalWidth, count) => {
      const width = Number(totalWidth);
      const n = Math.max(1, Math.floor(Number(count) || 1));
      if (!Number.isFinite(width) || width <= 0) return [];
      const base = Math.floor(width / n);
      let remainder = Math.round(width - base * n);
      if (!Number.isFinite(remainder) || remainder < 0) remainder = 0;
      const widths = Array.from({ length: n }, (_, idx) => base + (idx < remainder ? 1 : 0));
      return widths;
    };

    if (!enabled) {
      const width = Number(widthMm);
      return { count: 1, unitWidthMm: width, unitWidthsMm: buildUnitWidths(width, 1) };
    }

    let thresholdMm = Number.isFinite(Number(modular && modular.split_threshold_mm)) ? Number(modular.split_threshold_mm) : 1500;
    // Lowline bookcases can be built as a single carcass up to 1800W (e.g. standard 3x6).
    if ((/lowline/i.test(category) || /lowline/i.test(tagHint)) && thresholdMm < 1800) thresholdMm = 1800;
    const width = Number(widthMm);
    if (!Number.isFinite(width) || width <= 0 || width <= thresholdMm) {
      return { count: 1, unitWidthMm: width, unitWidthsMm: buildUnitWidths(width, 1) };
    }

    const preferredMin = Number.isFinite(Number(modular && modular.preferred_min_mm)) ? Number(modular.preferred_min_mm) : 900;
    const preferredMax = Number.isFinite(Number(modular && modular.preferred_max_mm)) ? Number(modular.preferred_max_mm) : 1200;
    const maxUnitWidth = Number.isFinite(Number(modular && modular.max_unit_width_mm)) ? Number(modular.max_unit_width_mm) : 1500;
    const maxUnits = Number.isFinite(Number(modular && modular.max_units)) ? Math.max(2, Math.floor(Number(modular.max_units))) : 6;

    const maxCount = Math.min(maxUnits, Math.max(2, Math.ceil(width / Math.max(1, preferredMin))));
    let best = null;
    let bestUnitWidth = null;

    for (let count = 2; count <= maxCount; count += 1) {
      const unitWidth = width / count;
      if (!Number.isFinite(unitWidth) || unitWidth <= 0) continue;
      if (unitWidth > maxUnitWidth) continue;

      const inPreferred = unitWidth >= preferredMin && unitWidth <= preferredMax;
      const distanceToRange = unitWidth < preferredMin ? preferredMin - unitWidth : unitWidth > preferredMax ? unitWidth - preferredMax : 0;
      const fractionalPenalty = Math.abs(unitWidth - Math.round(unitWidth));
      const countPenalty = count - 2;
      const score = (inPreferred ? 0 : 1000 + distanceToRange) + countPenalty + fractionalPenalty * 0.01;

      if (best == null || score < best) {
        best = score;
        bestUnitWidth = unitWidth;
      }
    }

    if (bestUnitWidth == null) {
      const count = Math.max(2, Math.ceil(width / Math.max(1, maxUnitWidth)));
      return { count, unitWidthMm: width / count, unitWidthsMm: buildUnitWidths(width, count) };
    }

    // Reconstruct count by rounding width / unitWidth to an integer (safe because we only compare by score).
    const count = Math.max(2, Math.round(width / bestUnitWidth));
    return { count, unitWidthMm: width / count, unitWidthsMm: buildUnitWidths(width, count) };
  };

  const getStepValueText = (stepId) => {
    const state = buildState();

    if (stepId === 'size') {
      const label = state.sizeLabel || '';
      try {
        const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
        const dims = getSizeDimensionsMmForState(state.sizeCode, state);
        if (!pricing || !dims) return label;
        const split = getModularSplitForWidth(dims.widthMm, pricing);
        if (split && split.count > 1) return `${label} x ${split.count} units`;
      } catch {
        // ignore
      }
      return label;
    }
    if (stepId === 'material') return state.materialLabel || '';
    if (stepId === 'finishType') return state.finishTypeLabel || '';
    if (stepId === 'colour') return state.colourLabel || '';
    if (stepId === 'twoTone') return state.twoTone ? 'Yes' : 'No';
    if (stepId === 'depth') {
      if (isCustomSize(state)) {
        const customDepth = String(state.customDepthMm || '').trim();
        return customDepth ? `${customDepth}mm` : '';
      }
      return state.depthLabel || '';
    }
    if (stepId === 'drawers') {
      const raw = Number.parseInt(String(state.drawers || ''), 10);
      const count = Number.isFinite(raw) && raw > 0 ? raw : 1;
      return count === 1 ? '1 drawer' : `${count} drawers`;
    }
    if (stepId === 'shelves') {
      const parts = [];
      if (shelvesField && String(state.shelves || '').trim() !== '') parts.push(`${state.shelves} shelves`);
      if (state.adjustableShelves) parts.push('Adjustable');
      return parts.join(' - ');
    }
    if (stepId === 'notes') return state.notes && String(state.notes).trim() ? 'Added' : '';

    if (stepId && stepId.startsWith('slot-')) {
      const key = stepId.slice('slot-'.length);
      const finishSel = configuratorRoot.querySelector(`select[data-jr-config-finish-slot="${escapeAttrValue(key)}"]`);
      const colourSel = configuratorRoot.querySelector(`select[data-jr-config-colour-slot="${escapeAttrValue(key)}"]`);
      const finishLabel = finishSel instanceof HTMLSelectElement ? getSelectedText(finishSel) : '';
      const colourLabel = colourSel instanceof HTMLSelectElement ? getSelectedText(colourSel) : '';
      const bits = [finishLabel, colourLabel].filter(Boolean);
      return bits.join(' / ');
    }

    return '';
  };

  const updateStepSummaries = () => {
    if (!(stepsContainer instanceof HTMLElement)) return;
    getSteps().forEach((step) => {
      if (!isStepVisible(step)) return;
      const stepId = String(step.dataset.jrStep || '');
      const valueEl = stepsContainer.querySelector(`[data-jr-step-value="${escapeAttrValue(stepId)}"]`);
      if (!(valueEl instanceof HTMLElement)) return;
      const text = getStepValueText(stepId);
      const cleanText = String(text || '')
        .replace(/[^\x20-\x7E]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      const complete = isStepComplete(step);
      valueEl.textContent = cleanText || 'Select';
      valueEl.dataset.jrStepComplete = complete ? '1' : '0';
      step.dataset.jrStepComplete = complete ? '1' : '0';
    });
  };

  const updateStepperPricePosition = () => {
    if (!(stepperPriceEl instanceof HTMLElement)) return;
    if (!(stepsContainer instanceof HTMLElement)) return;
    if (stepperPriceEl.hidden) return;
    try {
      const stepsRect = stepsContainer.getBoundingClientRect();
      const openStep =
        getSteps()
          .filter(isStepVisible)
          .find((s) => s.open) || getSteps().filter(isStepVisible)[0];
      if (!openStep) return;
      const summary = openStep.querySelector('summary');
      if (!(summary instanceof HTMLElement)) return;
      const summaryRect = summary.getBoundingClientRect();
      const y = Math.max(0, Math.round(summaryRect.top - stepsRect.top));
      stepperPriceEl.style.transform = `translateY(${y}px)`;
    } catch {
      // ignore
    }
  };

  const openFirstIncompleteStep = () => {
    const steps = getSteps().filter(isStepVisible);
    if (steps.length === 0) return;
    const firstIncomplete = steps.find((s) => !isStepComplete(s));
    const target = firstIncomplete || steps[0];
    target.open = true;
    closeOtherSteps(target);
  };

  const advanceFromTarget = (target) => {
    if (!(target instanceof HTMLElement)) return;
    const current = target.closest('details[data-jr-step]');
    if (!(current instanceof HTMLDetailsElement)) return;
    if (!isStepComplete(current)) return;

    // Only auto-advance for explicit choices (select, tiles, swatches). Don't jump while typing notes.
    const isChoice =
      target instanceof HTMLSelectElement ||
      target.closest('[data-jr-tile-value]') ||
      target.closest('[data-jr-config-colour-swatches]') ||
      target.closest('[data-jr-config-field="drawers"]') ||
      target.closest('[data-jr-config-field="shelves"]') ||
      target.closest('[data-jr-config-field="adjustableShelves"]') ||
      target.closest('[data-jr-config-field="twoTone"]');
    if (!isChoice) return;

    // Keep colour steps open so the large preview is visible.
    try {
      const stepId = String(current.dataset.jrStep || '');
      const isColourStep = stepId === 'colour' || stepId.startsWith('slot-');
      const isColourChoice =
        (target instanceof HTMLSelectElement && target.matches('select[data-jr-config-colour-slot]')) ||
        Boolean(target.closest('[data-jr-config-colour-swatches]'));
      if (isColourStep && isColourChoice) return;
    } catch {
      // ignore
    }

    const steps = getSteps().filter(isStepVisible);
    const idx = steps.indexOf(current);
    if (idx === -1) return;
    const next = steps.slice(idx + 1).find((s) => isStepVisible(s));
    if (!next) {
      current.open = false;
      return;
    }
    next.open = true;
    closeOtherSteps(next);
  };

  const openDialog = (title, body) => {
    const titleText = String(title || '').trim();
    const bodyText = String(body || '').trim();
    if (!titleText && !bodyText) return;

    if (dialogEl && typeof dialogEl.showModal === 'function') {
      if (dialogTitleEl instanceof HTMLElement) dialogTitleEl.textContent = titleText;
      if (dialogBodyEl instanceof HTMLElement) {
        dialogBodyEl.innerHTML = `<p>${escapeHtml(bodyText).replaceAll('\n', '<br>')}</p>`;
      }
      try {
        dialogEl.showModal();
      } catch {
        // If already open, ignore.
      }
      return;
    }

    // Fallback for environments without <dialog> support.
    alert(`${titleText}\n\n${bodyText}`);
  };

  const FINISH_STEP_HELP = {
    title: 'Finishes',
    body: `Raw & Stain\n- Best for natural timber look.\n- Grain and colour will vary naturally.\n\nPainted\n- Produced on MDF for a smoother, more consistent painted finish.\n\nWhy not paint Pine?\n- Pine is better suited to raw/stained finishes where the timber grain is part of the look.`,
  };

  if (dialogEl && dialogCloseBtn instanceof HTMLElement) {
    dialogCloseBtn.addEventListener('click', () => {
      try {
        dialogEl.close();
      } catch {
        // ignore
      }
    });
  }

  if (dialogEl && dialogEl instanceof HTMLElement) {
    dialogEl.addEventListener('click', (ev) => {
      // Close when clicking the backdrop / outside the dialog content.
      if (ev.target === dialogEl) {
        try {
          dialogEl.close();
        } catch {
          // ignore
        }
      }
    });
  }

  const parseLabelParts = (label) => {
    const text = String(label || '').trim();
    const idx = text.indexOf('(');
    if (idx === -1) return { title: text, meta: '' };
    const title = text.slice(0, idx).trim();
    const meta = text.slice(idx).replaceAll('(', '').replaceAll(')', '').trim();
    return { title, meta };
  };

  const renderTilesForSelect = (selectEl, containerEl, opts = {}) => {
    if (!(selectEl instanceof HTMLSelectElement) || !(containerEl instanceof HTMLElement)) return;

    const help = opts.help && typeof opts.help === 'object' ? opts.help : null;
    const showHelp = Boolean(help);

    const partsTitleForOption = (sel, value) => {
      const opt = Array.from(sel.options || []).find((x) => String(x.value || '') === String(value || ''));
      const label = opt ? String(opt.textContent || '') : String(value || '');
      const parts = opts.parseLabel ? opts.parseLabel(label) : { title: label, meta: '' };
      return parts.title || label;
    };

    const current = String(selectEl.value || '');
    const filterOption = typeof opts.filterOption === 'function' ? opts.filterOption : null;
    const tileClassForValue = typeof opts.tileClassForValue === 'function' ? opts.tileClassForValue : null;
    const options = Array.from(selectEl.options || [])
      .filter((o) => o && String(o.value || '').trim() !== '')
      .filter((o) => (filterOption ? Boolean(filterOption(String(o.value || ''), o)) : true));

    if (options.length === 0) {
      containerEl.hidden = true;
      return;
    }

    const html = options
      .map((o) => {
        const value = String(o.value || '');
        const selected = value && value === current ? 'true' : 'false';
        const disabled = Boolean(o.disabled);
        const parts = opts.parseLabel ? opts.parseLabel(String(o.textContent || '')) : { title: String(o.textContent || ''), meta: '' };
        const helpMsg = showHelp && help && help[value] ? String(help[value]) : '';
        const hasHelp = Boolean(helpMsg);
        const helpBtn = hasHelp
          ? `<button type="button" class="jr-option-help jr-option-help--corner" data-jr-option-help="${escapeAttr(value)}" aria-label="About ${escapeAttr(parts.title)}">i</button>`
          : '';

        // NOTE: Avoid nesting <button> inside <button> (invalid HTML). Use a div with button semantics.
        const extraClass = tileClassForValue ? String(tileClassForValue(value) || '').trim() : '';
        const hasHelpClass = hasHelp ? ' jr-option-tile--has-help' : '';
        const disabledClass = disabled ? ' jr-option-tile--disabled' : '';
        const classAttr = `jr-option-tile${hasHelpClass}${disabledClass}${extraClass ? ` ${escapeAttr(extraClass)}` : ''}`;
        const pressedAttr = disabled ? 'false' : selected;
        const ariaDisabledAttr = disabled ? 'true' : 'false';
        const tabIndex = disabled ? '-1' : '0';
        return `<div class="${classAttr}" role="button" data-jr-tile-value="${escapeAttr(
          value
        )}" aria-pressed="${pressedAttr}" aria-disabled="${ariaDisabledAttr}" tabindex="${tabIndex}">
          ${helpBtn}
          <div class="jr-option-tile__inner">
            <div class="jr-option-tile__title">${escapeHtml(parts.title)}</div>
            ${parts.meta ? `<div class="jr-option-tile__meta">${escapeHtml(parts.meta)}</div>` : ''}
          </div>
        </div>`;
      })
      .join('');

    containerEl.innerHTML = html;
    containerEl.hidden = false;

    // Hide the native select visually (keep for accessibility + form compatibility).
    selectEl.classList.add('visually-hidden');

    const setValue = (value) => {
      selectEl.value = value;
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    };

    containerEl.onclick = (ev) => {
      const target = ev.target instanceof HTMLElement ? ev.target : null;
      if (!target) return;

      const helpButton = target.closest('[data-jr-option-help]');
      if (helpButton) {
        const key = helpButton.getAttribute('data-jr-option-help') || '';
        const msg = help && help[key] ? String(help[key]) : '';
        if (msg) openDialog(partsTitleForOption(selectEl, key), msg);
        return;
      }

      const tile = target.closest('[data-jr-tile-value]');
      if (!tile) return;
      if (tile.getAttribute('aria-disabled') === 'true') return;
      const value = tile.getAttribute('data-jr-tile-value') || '';
      setValue(value);
    };

    containerEl.onkeydown = (ev) => {
      if (!(ev instanceof KeyboardEvent)) return;
      const target = ev.target instanceof HTMLElement ? ev.target : null;
      if (!target) return;
      const tile = target.closest('[data-jr-tile-value]');
      if (!tile) return;
      if (tile.getAttribute('aria-disabled') === 'true') return;
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      ev.preventDefault();
      const value = tile.getAttribute('data-jr-tile-value') || '';
      setValue(value);
    };
  };

  const computeLeadTime = (state) => {
    const rules = config && typeof config.leadTimeRules === 'object' && config.leadTimeRules ? config.leadTimeRules : null;
    const defaultText = rules && rules.default ? String(rules.default) : '';
    const byMaterialRaw = rules ? rules.by_material || rules.byMaterial : null;
    const byFinishRaw = rules ? rules.by_finish || rules.byFinish : null;
    const byMaterial = byMaterialRaw && typeof byMaterialRaw === 'object' ? byMaterialRaw : null;
    const byFinish = byFinishRaw && typeof byFinishRaw === 'object' ? byFinishRaw : null;
    const customSizeText = rules && (rules.custom_size || rules.customSize || rules.custom) ? String(rules.custom_size || rules.customSize || rules.custom) : '';
    const note = rules && rules.note ? String(rules.note) : '';

    let text = defaultText;

    if (isCustomSize(state) && customSizeText) {
      text = customSizeText;
    } else {
      if (byMaterial && state.materialCode && byMaterial[state.materialCode]) {
        text = String(byMaterial[state.materialCode]);
      }

      const finishEntries = state.finishTypes && typeof state.finishTypes === 'object' ? Object.values(state.finishTypes) : [];
      const finishCodes =
        finishEntries.length > 0
          ? finishEntries.map((v) => (v && typeof v === 'object' ? String(v.code || '') : '')).filter(Boolean)
          : [String(state.finishTypeCode || '')].filter(Boolean);

      if (byFinish && finishCodes.length > 0) {
        finishCodes.forEach((code) => {
          if (!code) return;
          if (byFinish[code]) text = String(byFinish[code]);
        });
      }
    }

    if (!text) {
      const fallback = config && config.leadTimeText ? String(config.leadTimeText) : '';
      return { text: fallback, note };
    }

    return { text, note };
  };

  const normalizeCode = (value) => String(value || '').trim().toLowerCase();

  const getAllowedFinishCodesForMaterial = (materialCode) => {
    const code = normalizeCode(materialCode);
    if (code === 'pine') return ['raw', 'stain'];
    if (code === 'mdf') return ['painted'];
    return ['raw', 'stain', 'painted'];
  };

  const renderOptionTiles = () => {
    try {
      const state = buildState();
      const materialCode = normalizeCode(state.materialCode);
      const allowedFinishCodes = getAllowedFinishCodesForMaterial(materialCode);
      const isAllowedFinish = (value) => !materialCode || allowedFinishCodes.includes(normalizeCode(value));

      renderTilesForSelect(sizeField, sizeStandardTilesEl, {
        parseLabel: parseLabelParts,
        filterOption: (value) => String(value) !== '__custom__',
      });
      renderTilesForSelect(sizeField, sizeCustomTilesEl, {
        parseLabel: () => ({ title: 'Custom size', meta: 'Enter your exact measurements' }),
        filterOption: (value) => String(value) === '__custom__',
        tileClassForValue: () => 'jr-option-tile--custom',
      });
      renderTilesForSelect(materialField, materialTilesEl, {
        parseLabel: (label) => ({ title: String(label || '').trim(), meta: '' }),
        help: config && typeof config.materialHelp === 'object' && config.materialHelp ? config.materialHelp : null,
      });

      renderTilesForSelect(finishTypeField, finishTilesEl, {
        parseLabel: (label) => ({ title: String(label || '').trim(), meta: '' }),
        filterOption: (value) => isAllowedFinish(value),
      });

      // Multi-slot (Top/Base/etc) finish selectors.
      try {
        getFinishSelects().forEach((select) => {
          if (!(select instanceof HTMLSelectElement)) return;
          const slot = String(select.dataset.jrConfigFinishSlot || '').trim();
          if (!slot || slot === 'main') return;
          const container = configuratorRoot.querySelector(`[data-jr-option-tiles="finishType-${escapeAttrValue(slot)}"]`);
          renderTilesForSelect(select, container, {
            parseLabel: (label) => ({ title: String(label || '').trim(), meta: '' }),
            filterOption: (value) => isAllowedFinish(value),
          });
        });
      } catch {
        // ignore
      }
    } catch {
      // ignore
    }
  };

  const syncFinishAvailability = () => {
    const state = buildState();
    const materialCode = normalizeCode(state.materialCode);

    const allowed = getAllowedFinishCodesForMaterial(materialCode);

    const applyToSelect = (selectEl) => {
      if (!(selectEl instanceof HTMLSelectElement)) return;
      const opts = Array.from(selectEl.options || []);
      opts.forEach((o) => {
        if (!(o instanceof HTMLOptionElement)) return;
        const valCode = normalizeCode(o.value);
        if (!valCode) return;
        const ok = !materialCode || allowed.includes(valCode);
        o.disabled = !ok;
        o.hidden = !ok;
      });

      const pickOptionValue = (targetCode) => {
        const match = opts.find(
          (o) => o instanceof HTMLOptionElement && normalizeCode(o.value) === targetCode && !o.disabled
        );
        return match ? String(match.value || '') : '';
      };

      const currentVal = normalizeCode(selectEl.value);
      if (!currentVal && materialCode && allowed.length === 1) {
        const onlyValue = pickOptionValue(allowed[0]);
        if (onlyValue) selectEl.value = onlyValue;
        return;
      }
      if (!currentVal) return;
      if (materialCode && !allowed.includes(currentVal)) {
        const nextValue = allowed.map((c) => pickOptionValue(c)).find(Boolean) || '';
        selectEl.value = nextValue;
      }
    };

    if (finishTypeField instanceof HTMLSelectElement) applyToSelect(finishTypeField);
    getFinishSelects().forEach((select) => applyToSelect(select));
  };

  const syncCustomSizeFields = () => {
    const state = buildState();
    const custom = isCustomSize(state);
    const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
    const constraints = getCustomConstraints(pricing);

    customSizeWrappers.forEach((el) => {
      el.hidden = !custom;
    });

    if (depthFieldWrapper) depthFieldWrapper.hidden = custom;
    if (customDepthWrapper) customDepthWrapper.hidden = !custom;

    if (custom) {
      if (depthField) depthField.value = '';
      if (customWidthField) customWidthField.required = true;
      if (customHeightField) customHeightField.required = true;
      if (customDepthField) customDepthField.required = true;

      if (constraints) {
        if (customWidthField) {
          if (Number.isFinite(constraints.minWidthMm)) customWidthField.min = String(constraints.minWidthMm);
          else customWidthField.min = '1';
          if (Number.isFinite(constraints.maxWidthMm)) customWidthField.max = String(constraints.maxWidthMm);
          else customWidthField.removeAttribute('max');
        }
        if (customHeightField) {
          if (Number.isFinite(constraints.minHeightMm)) customHeightField.min = String(constraints.minHeightMm);
          else customHeightField.min = '1';
          if (Number.isFinite(constraints.maxHeightMm)) customHeightField.max = String(constraints.maxHeightMm);
          else customHeightField.removeAttribute('max');
        }
        if (customDepthField) {
          if (Number.isFinite(constraints.minDepthMm)) customDepthField.min = String(constraints.minDepthMm);
          else customDepthField.min = '1';
          if (Number.isFinite(constraints.maxDepthMm)) customDepthField.max = String(constraints.maxDepthMm);
          else customDepthField.removeAttribute('max');
        }
      } else {
        if (customWidthField) customWidthField.min = '1';
        if (customWidthField) customWidthField.removeAttribute('max');
        if (customHeightField) customHeightField.min = '1';
        if (customHeightField) customHeightField.removeAttribute('max');
        if (customDepthField) {
          customDepthField.min = '1';
          customDepthField.removeAttribute('max');
        }
      }

      if (customConstraintsEl instanceof HTMLElement) {
        if (!constraints) {
          customConstraintsEl.hidden = true;
          customConstraintsEl.textContent = '';
        } else {
          const fmt = (min, max, label) => {
            if (Number.isFinite(min) && Number.isFinite(max)) return `${label} ${min}\u2013${max}mm`;
            if (Number.isFinite(min)) return `${label} \u2265 ${min}mm`;
            if (Number.isFinite(max)) return `${label} \u2264 ${max}mm`;
            return '';
          };
          const parts = [
            fmt(constraints.minWidthMm, constraints.maxWidthMm, 'W'),
            fmt(constraints.minHeightMm, constraints.maxHeightMm, 'H'),
            fmt(constraints.minDepthMm, constraints.maxDepthMm, 'D'),
          ].filter(Boolean);
          customConstraintsEl.textContent = parts.length ? `Limits: ${parts.join(' \u2022 ')}` : '';
          customConstraintsEl.hidden = !customConstraintsEl.textContent;
        }
      }
    } else {
      if (customWidthField) customWidthField.required = false;
      if (customHeightField) customHeightField.required = false;
      if (customDepthField) customDepthField.required = false;
      if (customConstraintsEl instanceof HTMLElement) {
        customConstraintsEl.hidden = true;
        customConstraintsEl.textContent = '';
      }
    }
  };

  const getBoardForSelection = (materialCode, finishTypeCode) => {
    if (finishTypeCode === 'painted') return 'paint';
    if (String(materialCode || '').startsWith('tassy')) return 'tassy';
    return 'pine';
  };

  // Legacy compatibility: early seeds used "(Brushed)" labels and *_brushed codes.
  // We no longer offer brushed paint; normalize so the UI stays clean without requiring immediate reseeds.
  const normalizeColourCode = (code) => String(code || '').replace(/[_-]brushed$/i, '');
  const normalizeColourLabel = (label) => {
    const cleaned = String(label || '')
      .replace(/\s*\(brushed\)\s*/gi, ' ')
      .replace(/\bbrushed\b/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return cleaned;
  };
  const normalizeColourEntry = (c) => {
    if (!c || typeof c !== 'object') return c;
    const next = { ...c };
    next.code = normalizeColourCode(next.code);
    next.label = normalizeColourLabel(next.label || next.code);
    return next;
  };

  const getAllColours = () => {
    const localRaw = Array.isArray(config.colours) ? config.colours : Array.isArray(config.finishes) ? config.finishes : [];
    const globalRaw = Array.isArray(config.globalColours) ? config.globalColours : [];
    const local = localRaw.map(normalizeColourEntry).filter(Boolean);
    const global = globalRaw.map(normalizeColourEntry).filter(Boolean);

    const keyFor = (c) => `${String(c.type || '')}:${String(c.board || '')}:${String(c.code || '')}`;
    const urlFor = (c) => (c && (c.image_url || c.imageUrl || c.image) ? String(c.image_url || c.imageUrl || c.image) : '');

    const preferWithImage = (prev, next) => {
      if (!prev) return next;
      if (!next) return prev;
      const prevUrl = urlFor(prev);
      const nextUrl = urlFor(next);
      if (!prevUrl && nextUrl) return next;
      return prev;
    };

    const globalMap = new Map();
    global.forEach((c) => {
      const key = keyFor(c);
      globalMap.set(key, preferWithImage(globalMap.get(key), c));
    });

    const localOrder = [];
    const localMap = new Map();
    local.forEach((c) => {
      const key = keyFor(c);
      if (!localMap.has(key)) localOrder.push(key);
      localMap.set(key, preferWithImage(localMap.get(key), c));
    });

    const out = [];

    localOrder.forEach((key) => {
      const c = localMap.get(key);
      const g = globalMap.get(key);
      if (c && g && !urlFor(c) && urlFor(g)) out.push({ ...c, image_url: urlFor(g) });
      else if (c) out.push(c);
    });

    globalMap.forEach((c, key) => {
      if (localMap.has(key)) return;
      if (c) out.push(c);
    });

    return out;
  };

  const getColourOptions = (state, finishTypeCode) => {
    const all = getAllColours();
    const board = getBoardForSelection(state.materialCode, finishTypeCode);
    return all.filter(
      (f) =>
        f &&
        String(f.board || '') === board &&
        String(f.type || '') === String(finishTypeCode || '') &&
        String(f.code || '') !== ''
    );
  };

    const isMultiSlotMode = () => (config && config.colourSlotMode ? String(config.colourSlotMode) === 'multi' : false);

    const getFinishCodeForSlot = (state, slot) => {
      const finishesBySlot = state.finishTypes && typeof state.finishTypes === 'object' ? state.finishTypes : {};
      const slotCode = finishesBySlot[slot] && typeof finishesBySlot[slot] === 'object' ? String(finishesBySlot[slot].code || '') : '';
      if (slotCode) return slotCode;
      return String(state.finishTypeCode || '');
    };

    const syncTwoToneVisibility = () => {
      const state = buildState();
      const enabled = Boolean(state.twoTone);

      const baseSteps = Array.from(configuratorRoot.querySelectorAll('[data-jr-two-tone="base-step"]')).filter(
        (el) => el instanceof HTMLElement
      );
      baseSteps.forEach((step) => {
        step.hidden = !enabled;
        if (step instanceof HTMLDetailsElement) {
          if (!enabled) step.open = false;
          if (enabled) step.open = true;
        }
      });

      const labelEls = Array.from(configuratorRoot.querySelectorAll('[data-jr-two-tone-label]')).filter(
        (el) => el instanceof HTMLElement
      );
      labelEls.forEach((el) => {
        const onText = el.getAttribute('data-jr-two-tone-on');
        const offText = el.getAttribute('data-jr-two-tone-off');
        const next = enabled ? onText : offText;
        if (!next) return;
        el.textContent = String(next);
      });

      const baseControls = Array.from(configuratorRoot.querySelectorAll('[data-jr-two-tone-slot="base"]')).filter(
        (el) => el instanceof HTMLSelectElement || el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement
      );

      baseControls.forEach((el) => {
        // When disabled, fields should not participate in validation or selection state.
        el.disabled = !enabled;
        if (!enabled) {
          if (el instanceof HTMLSelectElement) el.value = '';
          if (el instanceof HTMLInputElement && el.type !== 'checkbox' && el.type !== 'radio') el.value = '';
          if (el instanceof HTMLTextAreaElement) el.value = '';
        }
      });
    };

    const syncColourField = () => {
      const colourSelects = getColourSelects();
      if (!colourFieldWrapper || colourSelects.length === 0) return;

      const state = buildState();
      const finishesBySlot = state.finishTypes && typeof state.finishTypes === 'object' ? state.finishTypes : {};
      const hasPerSlotFinishes = isMultiSlotMode() && Object.keys(finishesBySlot).length > 0;
      const finishSelects = getFinishSelects();
      finishSelects.forEach((select) => {
        if (select instanceof HTMLSelectElement) select.required = true;
      });

      const escapeHtml = (text) => String(text).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');
      const escapeAttr = (text) => escapeHtml(text).replaceAll('"', '&quot;').replaceAll("'", '&#39;');

      let anySlotNeedsColour = false;

      colourSelects.forEach((select) => {
        if (!(select instanceof HTMLSelectElement)) return;
        const currentRaw = select.value;
        const current = normalizeColourCode(currentRaw);
        const slot = String(select.dataset.jrConfigColourSlot || 'main');
        const finishTypeCode = hasPerSlotFinishes ? String((finishesBySlot[slot] && finishesBySlot[slot].code) || '') : getFinishCodeForSlot(state, slot);

        const needsColour = finishTypeCode && finishTypeCode !== 'raw';
        anySlotNeedsColour = anySlotNeedsColour || Boolean(needsColour);

        const wrapper = select.closest('[data-jr-config-colour-field-item]');
        const preview = wrapper ? wrapper.querySelector('[data-jr-config-colour-preview]') : null;
        const previewImg = wrapper ? wrapper.querySelector('[data-jr-config-colour-preview-image]') : null;
        const swatches = wrapper ? wrapper.querySelector('[data-jr-config-colour-swatches]') : null;

        if (!finishTypeCode) {
          select.value = '';
          select.required = false;
          select.innerHTML = '<option value="">Select finish first</option>';
          if (preview instanceof HTMLElement) preview.hidden = true;
          if (previewImg instanceof HTMLImageElement) previewImg.removeAttribute('src');
          if (swatches instanceof HTMLElement) {
            swatches.hidden = true;
            swatches.innerHTML = '';
          }
          select.classList.remove('visually-hidden');
          return;
        }

        if (!needsColour) {
          select.value = '';
          select.required = false;
          select.innerHTML = '<option value="">No colour needed (Raw)</option>';
          if (preview instanceof HTMLElement) preview.hidden = true;
          if (previewImg instanceof HTMLImageElement) previewImg.removeAttribute('src');
          if (swatches instanceof HTMLElement) {
            swatches.hidden = true;
            swatches.innerHTML = '';
          }
          select.classList.remove('visually-hidden');
          return;
        }

        const opts = getColourOptions(state, finishTypeCode);
        const hasOptions = Array.isArray(opts) && opts.length > 0;

        if (!hasOptions) {
          select.innerHTML = '<option value="">No colours available</option>';
          select.value = '';
          select.required = false;
        } else {
          select.innerHTML = `<option value="">Select colour</option>${opts
            .map((o) => `<option value="${escapeAttr(o.code)}">${escapeHtml(o.label)}</option>`)
            .join('')}`;
          const nextValue = current && opts.some((o) => String(o.code) === String(current)) ? current : '';
          select.value = nextValue;
          select.required = true;
        }

        if (preview instanceof HTMLElement && previewImg instanceof HTMLImageElement) {
          const selected = opts.find((o) => String(o.code) === String(select.value));
          const url = selected && (selected.image_url || selected.imageUrl || selected.image) ? String(selected.image_url || selected.imageUrl || selected.image) : '';
          if (url) {
            preview.hidden = false;
            previewImg.src = url;
          } else {
            preview.hidden = true;
            previewImg.removeAttribute('src');
          }
        }

        if (swatches instanceof HTMLElement) {
          if (!hasOptions) {
            swatches.hidden = true;
            swatches.innerHTML = '';
            select.classList.remove('visually-hidden');
          } else {
            const selectedCode = String(select.value || '');
            const escapeHtml = (text) =>
              String(text).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');
            const escapeAttr = (text) => escapeHtml(text).replaceAll('"', '&quot;').replaceAll("'", '&#39;');

            swatches.innerHTML = opts
              .map((o) => {
                const code = String(o.code || '');
                const label = String(o.label || code);
                const url = o.image_url || o.imageUrl || o.image ? String(o.image_url || o.imageUrl || o.image) : '';
                const pressed = code && code === selectedCode ? 'true' : 'false';
                const img = url ? `<img src="${escapeAttr(url)}" alt="" loading="lazy">` : '';
                return `<button type="button" class="jr-configurator__swatch" data-jr-swatch-code="${escapeAttr(
                  code
                )}" aria-pressed="${pressed}">${img}<span class="jr-configurator__swatch-label">${escapeHtml(label)}</span></button>`;
              })
              .join('');

            swatches.hidden = false;
            // Hide the native select visually (keep it for accessibility + form compatibility).
            select.classList.add('visually-hidden');

            // Delegate click events from the container (re-rendered each time).
            swatches.onclick = (ev) => {
              const target = ev.target instanceof HTMLElement ? ev.target.closest('[data-jr-swatch-code]') : null;
              if (!target) return;
              const code = target.getAttribute('data-jr-swatch-code') || '';
              select.value = code;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            };
          }
        }
      });

      const multiMode = isMultiSlotMode();
      colourFieldWrapper.hidden = multiMode ? false : !anySlotNeedsColour;
    };

  const getSizeDimensionsMmForState = (sizeCode, state) => {
    if (sizeCode === '__custom__') {
      const widthMm = Number(state.customWidthMm);
      const heightMm = Number(state.customHeightMm);
      const depthMm = Number(state.customDepthMm);
      if (!Number.isFinite(widthMm) || !Number.isFinite(heightMm) || widthMm <= 0 || heightMm <= 0) return null;
      if (!Number.isFinite(depthMm) || depthMm <= 0) return null;
      return { widthMm, heightMm, depthMm };
    }

    const sizes = Array.isArray(config.sizes) ? config.sizes : [];
    const size = sizes.find((s) => s && String(s.code) === String(sizeCode));
    if (size && size.width_mm && size.height_mm) {
      return {
        widthMm: Number(size.width_mm),
        heightMm: Number(size.height_mm),
        depthMm: size.depth_mm ? Number(size.depth_mm) : null,
      };
    }

    const label = size && size.label ? String(size.label) : '';
    const match = label.match(/(\d+)\s*H\s*x\s*(\d+)\s*W/i);
    if (match) {
      return { widthMm: Number(match[2]), heightMm: Number(match[1]), depthMm: null };
    }

    return null;
  };

  const getSizeDimensionsMm = (sizeCode) => getSizeDimensionsMmForState(sizeCode, buildState());

  const getSelectedDepthMm = (state, dims) => {
    if (isCustomSize(state) && dims && dims.depthMm) return dims.depthMm;

    if (depthField && depthField.value) {
      const options = Array.isArray(config.depthOptions) ? config.depthOptions : [];
      const opt = options.find((o) => o && String(o.code) === String(depthField.value));
      if (opt && opt.depth_mm) return Number(opt.depth_mm);
    }

    if (dims && dims.depthMm) return Number(dims.depthMm);
    return null;
  };

  const getMaxShelves = (heightMm) => {
    const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
    const minSpacingMm = pricing && Number.isFinite(Number(pricing.min_shelf_spacing_mm)) ? Number(pricing.min_shelf_spacing_mm) : 200;
    return Math.max(0, Math.floor(Number(heightMm) / minSpacingMm) - 1);
  };

  const getMaxDrawers = (heightMm) => {
    const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
    const minDrawerHeightMm =
      pricing && pricing.drawer_rules && Number.isFinite(Number(pricing.drawer_rules.min_drawer_height_mm))
        ? Number(pricing.drawer_rules.min_drawer_height_mm)
        : 150;
    return Math.max(1, Math.floor(Number(heightMm) / minDrawerHeightMm) - 1);
  };

  const getRecommendedDrawers = (heightMm) => {
    const max = getMaxDrawers(heightMm);
    const recommended = Math.max(1, Math.round(Number(heightMm) / 250));
    return Math.min(max, recommended);
  };

  const getIncludedShelves = (heightMm) => {
    const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
    const perMm = pricing && Number.isFinite(Number(pricing.included_shelves_per_mm)) ? Number(pricing.included_shelves_per_mm) : null;
    const minIncluded = pricing && Number.isFinite(Number(pricing.min_included_shelves)) ? Number(pricing.min_included_shelves) : 2;
    const maxBySpacing = getMaxShelves(heightMm);

    let included;
    if (perMm) {
      included = Math.round(Number(heightMm) * perMm);
    } else {
      included = Math.round(Number(heightMm) / 450);
    }

    if (!Number.isFinite(included)) included = minIncluded;
    included = Math.max(minIncluded, included);
    included = Math.min(maxBySpacing, included);
    return included;
  };

  const syncShelfRules = () => {
    if (!shelvesField) return;

    const state = buildState();
    const dims = getSizeDimensionsMmForState(state.sizeCode, state);
    const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
    if (!dims) {
      shelvesField.removeAttribute('max');
      if (shelvesMaxEl) shelvesMaxEl.textContent = '';
      if (adjustableAddonEl instanceof HTMLElement) adjustableAddonEl.textContent = '';
      return;
    }

    const max = getMaxShelves(dims.heightMm);
    const included = getIncludedShelves(dims.heightMm);
    shelvesField.max = String(max);

    const getShelfAddonRuleForUnitWidthMm = (unitWidthMm, pricing) => {
      const rules = Array.isArray(pricing && pricing.shelf_addon_rules) ? pricing.shelf_addon_rules : [];
      const normalized = rules
        .map((r) => (r && typeof r === 'object' ? r : null))
        .filter(Boolean)
        .map((r) => ({
          max_width_mm: Number(r.max_width_mm),
          extra_shelf_addon: Number(r.extra_shelf_addon),
          adjustable_shelves_addon: Number(r.adjustable_shelves_addon),
        }))
        .filter((r) => Number.isFinite(r.max_width_mm) && r.max_width_mm > 0)
        .sort((a, b) => a.max_width_mm - b.max_width_mm);

      const fallbackExtra = Number(pricing && pricing.extra_shelf_addon);
      const fallbackAdj = Number(pricing && pricing.adjustable_shelves_addon);
      const fallback = {
        extra: Number.isFinite(fallbackExtra) ? fallbackExtra : 0,
        adjustable: Number.isFinite(fallbackAdj) ? fallbackAdj : 0,
      };
      if (!normalized.length || !Number.isFinite(Number(unitWidthMm)) || Number(unitWidthMm) <= 0) return fallback;

      const w = Number(unitWidthMm);
      const rule = normalized.find((r) => w <= r.max_width_mm) || normalized[normalized.length - 1];
      return {
        extra: Number.isFinite(rule.extra_shelf_addon) ? rule.extra_shelf_addon : fallback.extra,
        adjustable: Number.isFinite(rule.adjustable_shelves_addon) ? rule.adjustable_shelves_addon : fallback.adjustable,
      };
    };

    const materialMultipliers =
      pricing && pricing.material_multipliers && typeof pricing.material_multipliers === 'object' ? pricing.material_multipliers : {};
    const materialMultiplierRaw = materialMultipliers[state.materialCode];
    const materialMultiplier = Number.isFinite(Number(materialMultiplierRaw)) ? Number(materialMultiplierRaw) : 1;

    const finishMultipliers =
      pricing && pricing.finish_multipliers && typeof pricing.finish_multipliers === 'object' ? pricing.finish_multipliers : {};
    const finishEntries = state.finishTypes && typeof state.finishTypes === 'object' ? Object.values(state.finishTypes) : [];
    const finishCodes =
      finishEntries.length > 0
        ? finishEntries.map((v) => (v && typeof v === 'object' ? String(v.code || '') : '')).filter(Boolean)
        : [String(state.finishTypeCode || '')].filter(Boolean);
    let finishMultiplier = 1;
    finishCodes.forEach((code) => {
      const raw = finishMultipliers[code];
      const mult = Number.isFinite(Number(raw)) ? Number(raw) : 1;
      if (mult > finishMultiplier) finishMultiplier = mult;
    });

    const addonScale = materialMultiplier * finishMultiplier;

    const split = pricing ? getModularSplitForWidth(dims.widthMm, pricing) : null;
    const carcassCount = (split && split.count ? Number(split.count) : 1) || 1;
    const unitWidthsMm =
      split && Array.isArray(split.unitWidthsMm) && split.unitWidthsMm.length
        ? split.unitWidthsMm.map((n) => Number(n)).filter((n) => Number.isFinite(n) && n > 0)
        : [dims.widthMm];

    const unitAddons = unitWidthsMm.map((w) => {
      const rule = getShelfAddonRuleForUnitWidthMm(w, pricing);
      return {
        extra: rule.extra * addonScale,
        // Adjustable-shelves is a per-unit addon (hardware/labour) and does not scale by material/finish.
        adjustable: rule.adjustable,
      };
    });

    const unitExtraValues = unitAddons.map((a) => a.extra).filter((n) => Number.isFinite(n) && n > 0);
    const minExtra = unitExtraValues.length ? Math.min(...unitExtraValues) : 0;
    const maxExtra = unitExtraValues.length ? Math.max(...unitExtraValues) : 0;
    const totalPerExtraShelf = unitExtraValues.reduce((sum, v) => sum + v, 0);

    const perUnitText =
      maxExtra > 0 && Math.abs(minExtra - maxExtra) < 0.01
        ? formatMoney(maxExtra)
        : `${formatMoney(Math.max(0, minExtra))}–${formatMoney(Math.max(0, maxExtra))}`;
    const totalText = carcassCount > 1 && totalPerExtraShelf > 0 ? ` (${formatMoney(totalPerExtraShelf)} total per extra shelf)` : '';
    if (shelvesMaxEl) {
      shelvesMaxEl.textContent =
        maxExtra > 0
          ? `(includes ${included} per unit, +${perUnitText} per unit shelf over${totalText}, max ${max} per unit)`
          : `(includes ${included} per unit, max ${max} per unit)`;
    }

    if (adjustableAddonEl instanceof HTMLElement) {
      const unitAdjValues = unitAddons.map((a) => a.adjustable).filter((n) => Number.isFinite(n) && n > 0);
      const minAdj = unitAdjValues.length ? Math.min(...unitAdjValues) : 0;
      const maxAdj = unitAdjValues.length ? Math.max(...unitAdjValues) : 0;
      const totalAdj = unitAdjValues.reduce((sum, v) => sum + v, 0);
      if (maxAdj > 0) {
        const unitAdjText =
          Math.abs(minAdj - maxAdj) < 0.01
            ? formatMoney(maxAdj)
            : `${formatMoney(Math.max(0, minAdj))}–${formatMoney(Math.max(0, maxAdj))}`;
        adjustableAddonEl.textContent =
          carcassCount > 1 ? `(+${unitAdjText} per unit; ${formatMoney(totalAdj)} total)` : `(+${unitAdjText} per unit)`;
      } else {
        adjustableAddonEl.textContent = '';
      }
    }

    const current = Number.parseInt(shelvesField.value, 10);
    const currentSafe = Number.isFinite(current) ? current : included;
    if (!Number.isFinite(current) || shelvesField.value === '') shelvesField.value = String(included);
    if (currentSafe < included) shelvesField.value = String(included);
    if (currentSafe > max) shelvesField.value = String(max);
  };

  const syncDrawerRules = () => {
    if (!(drawersField instanceof HTMLInputElement)) return;

    const state = buildState();
    const dims = getSizeDimensionsMmForState(state.sizeCode, state);
    if (!dims) {
      drawersField.removeAttribute('max');
      if (drawersMaxEl) drawersMaxEl.textContent = '';
      return;
    }

    const max = getMaxDrawers(dims.heightMm);
    const recommended = getRecommendedDrawers(dims.heightMm);
    drawersField.min = '1';
    drawersField.max = String(max);

    if (drawersMaxEl) {
      drawersMaxEl.textContent = `(recommended ${recommended} for this height, max ${max})`;
    }

    const current = Number.parseInt(String(drawersField.value || ''), 10);
    const currentSafe = Number.isFinite(current) ? current : recommended;
    if (!Number.isFinite(current) || drawersField.value === '') drawersField.value = String(recommended);
    if (currentSafe < 1) drawersField.value = '1';
    if (currentSafe > max) drawersField.value = String(max);
  };

  const calculateEstimatedPriceForState = (state) => {
    const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
    if (!pricing) return null;

    const dims = getSizeDimensionsMmForState(state.sizeCode, state);
    if (!dims) return null;

    const widthM = dims.widthMm / 1000;
    const heightM = dims.heightMm / 1000;
    if (!Number.isFinite(widthM) || !Number.isFinite(heightM) || widthM <= 0 || heightM <= 0) return null;

    const areaM2 = widthM * heightM;
    const baseCost = Number(pricing.base_cost);
    const costPerM2 = Number(pricing.cost_per_m2);
    const sellMultiplier = Number(
      (config && config.pricingDefaults && config.pricingDefaults.sell_multiplier) ?? pricing.sell_multiplier ?? 1
    );

    if (![baseCost, costPerM2, sellMultiplier].every((n) => Number.isFinite(n))) return null;

    const categoryMultiplier = Number.isFinite(Number(pricing.category_multiplier)) ? Number(pricing.category_multiplier) : 1;
    const difficultyMultiplierOverride = Number(state.difficultyMultiplier);
    const tierMultipliers = pricing.tier_multipliers && typeof pricing.tier_multipliers === 'object' ? pricing.tier_multipliers : {};
    const tierMultiplierRaw = tierMultipliers[state.difficultyTier];
    const tierMultiplier = Number.isFinite(Number(tierMultiplierRaw)) ? Number(tierMultiplierRaw) : 1;
    const difficultyMultiplier = Number.isFinite(difficultyMultiplierOverride) && difficultyMultiplierOverride > 0 ? difficultyMultiplierOverride : tierMultiplier;

    const materialMultipliers =
      pricing.material_multipliers && typeof pricing.material_multipliers === 'object' ? pricing.material_multipliers : {};
    const materialMultiplierRaw = materialMultipliers[state.materialCode];
    const materialMultiplier = Number.isFinite(Number(materialMultiplierRaw)) ? Number(materialMultiplierRaw) : 1;

    const finishMultipliers =
      pricing.finish_multipliers && typeof pricing.finish_multipliers === 'object' ? pricing.finish_multipliers : {};

    const finishEntries = state.finishTypes && typeof state.finishTypes === 'object' ? Object.values(state.finishTypes) : [];
    const finishCodes =
      finishEntries.length > 0
        ? finishEntries.map((v) => (v && typeof v === 'object' ? String(v.code || '') : '')).filter(Boolean)
        : [String(state.finishTypeCode || '')].filter(Boolean);

    let finishMultiplier = 1;
    finishCodes.forEach((code) => {
      const raw = finishMultipliers[code];
      const mult = Number.isFinite(Number(raw)) ? Number(raw) : 1;
      if (mult > finishMultiplier) finishMultiplier = mult;
    });

    const difficultyCostMultiplier = difficultyMultiplier * materialMultiplier * finishMultiplier * categoryMultiplier;
    const baseDepthMm = Number.isFinite(Number(pricing.base_depth_mm)) ? Number(pricing.base_depth_mm) : 290;
    const selectedDepthMm = getSelectedDepthMm(state, dims);
    const depthScale =
      Number.isFinite(selectedDepthMm) && selectedDepthMm > 0 && Number.isFinite(baseDepthMm) && baseDepthMm > 0
        ? selectedDepthMm / baseDepthMm
        : 1;

    const modularSplit = getModularSplitForWidth(dims.widthMm, pricing);
    const carcassCount = (modularSplit && modularSplit.count ? Number(modularSplit.count) : 1) || 1;
    if (jrIsDebug() && carcassCount > 1) {
      try {
        console.log('JR debug: modular split', {
          presetKey: config && (config.presetKey || config.amcTag),
          widthMm: dims.widthMm,
          heightMm: dims.heightMm,
          carcassCount,
          unitWidthsMm: modularSplit && modularSplit.unitWidthsMm,
        });
      } catch {
        // ignore
      }
    }
    const unitWidthsMmRaw =
      modularSplit && Array.isArray(modularSplit.unitWidthsMm) && modularSplit.unitWidthsMm.length
        ? modularSplit.unitWidthsMm
        : [dims.widthMm];
    const unitWidthsMm = unitWidthsMmRaw
      .map((w) => Number(w))
      .filter((w) => Number.isFinite(w) && w > 0);
    const safeUnitWidthsMm = unitWidthsMm.length ? unitWidthsMm : [Number(dims.widthMm)];

    const modularCfg = pricing && pricing.modular_units && typeof pricing.modular_units === 'object' ? pricing.modular_units : null;
    const roundPerUnit = carcassCount > 1 ? (modularCfg ? modularCfg.round_per_unit !== false : true) : false;

    const unitFactoryCosts = safeUnitWidthsMm.map((unitWidthMm) => {
      const unitWidthM = Number(unitWidthMm) / 1000;
      if (!Number.isFinite(unitWidthM) || unitWidthM <= 0) return 0;
      const unitAreaM2 = unitWidthM * heightM;
      return baseCost + unitAreaM2 * costPerM2 * depthScale;
    });
    const factoryCost = unitFactoryCosts.reduce((sum, v) => sum + (Number.isFinite(v) ? v : 0), 0);

    const getShelfAddonRuleForUnitWidthMm = (unitWidthMm, pricing) => {
      const rules = Array.isArray(pricing && pricing.shelf_addon_rules) ? pricing.shelf_addon_rules : [];
      const normalized = rules
        .map((r) => (r && typeof r === 'object' ? r : null))
        .filter(Boolean)
        .map((r) => ({
          max_width_mm: Number(r.max_width_mm),
          extra_shelf_addon: Number(r.extra_shelf_addon),
          adjustable_shelves_addon: Number(r.adjustable_shelves_addon),
        }))
        .filter((r) => Number.isFinite(r.max_width_mm) && r.max_width_mm > 0)
        .sort((a, b) => a.max_width_mm - b.max_width_mm);

      const fallbackExtra = Number(pricing && pricing.extra_shelf_addon);
      const fallbackAdj = Number(pricing && pricing.adjustable_shelves_addon);
      const fallback = {
        extra: Number.isFinite(fallbackExtra) ? fallbackExtra : 0,
        adjustable: Number.isFinite(fallbackAdj) ? fallbackAdj : 0,
      };
      if (!normalized.length || !Number.isFinite(Number(unitWidthMm)) || Number(unitWidthMm) <= 0) return fallback;

      const w = Number(unitWidthMm);
      const rule = normalized.find((r) => w <= r.max_width_mm) || normalized[normalized.length - 1];
      return {
        extra: Number.isFinite(rule.extra_shelf_addon) ? rule.extra_shelf_addon : fallback.extra,
        adjustable: Number.isFinite(rule.adjustable_shelves_addon) ? rule.adjustable_shelves_addon : fallback.adjustable,
      };
    };

    const drawerRules = pricing.drawer_rules && typeof pricing.drawer_rules === 'object' ? pricing.drawer_rules : {};
    const drawerAddonRaw = drawerRules.drawer_cost_per_drawer ?? drawerRules.addon_per_drawer ?? 0;
    const drawerAddon = Number.isFinite(Number(drawerAddonRaw)) ? Number(drawerAddonRaw) : 0;
    const includedDrawersRaw = drawerRules.included_drawers ?? drawerRules.base_included_drawers ?? 0;
    const includedDrawers = Number.isFinite(Number(includedDrawersRaw)) ? Number(includedDrawersRaw) : 0;
    const includedShelves = getIncludedShelves(dims.heightMm);
    const shelvesCount = Number.parseInt(state.shelves, 10) || includedShelves;
    const chargedShelves = Math.max(0, shelvesCount - includedShelves);

    const drawersCountRaw = Number.parseInt(String(state.drawers || ''), 10);
    const drawersCount = Number.isFinite(drawersCountRaw) ? drawersCountRaw : includedDrawers;
    const chargedDrawers = Math.max(0, drawersCount - includedDrawers);

    const addonScale = materialMultiplier * finishMultiplier;
    const unitAddons = safeUnitWidthsMm.map((w) => {
      const rule = getShelfAddonRuleForUnitWidthMm(w, pricing);
      return {
        extra: (Number.isFinite(rule.extra) ? rule.extra : 0) * addonScale,
        // Adjustable-shelves is a per-unit addon (hardware/labour) and does not scale by material.
        adjustable: Number.isFinite(rule.adjustable) ? rule.adjustable : 0,
      };
    });
    const perExtraShelfTotal = unitAddons.reduce((sum, a) => sum + (Number.isFinite(a.extra) ? a.extra : 0), 0);
    const perAdjustableTotal = unitAddons.reduce((sum, a) => sum + (Number.isFinite(a.adjustable) ? a.adjustable : 0), 0);

    const extrasAddon =
      chargedShelves * perExtraShelfTotal +
      (state.adjustableShelves ? perAdjustableTotal : 0) +
      chargedDrawers * drawerAddon * carcassCount;

    const roundTo = Number.isFinite(Number(pricing.round_to)) && Number(pricing.round_to) > 0 ? Number(pricing.round_to) : 1;
    const unitEstimatedBase = unitFactoryCosts.map((fc) => (Number.isFinite(fc) ? fc : 0) * difficultyCostMultiplier * sellMultiplier);
    const baseEstimated = roundPerUnit
      ? unitEstimatedBase.reduce((sum, v) => sum + (Math.round(v / roundTo) * roundTo), 0)
      : unitEstimatedBase.reduce((sum, v) => sum + (Number.isFinite(v) ? v : 0), 0);

    const estimated = baseEstimated + extrasAddon;
    const rounded = Math.round(estimated / roundTo) * roundTo;

    return rounded;
  };

  const calculateEstimatedPrice = () => calculateEstimatedPriceForState(buildState());

  const renderStartingFromPrice = () => {
    if (!(startingPriceEl instanceof HTMLElement)) return;
    try {
      const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
      if (!pricing) return;

      const sizes = Array.isArray(config.sizes) ? config.sizes : [];
      const sizeCodes = sizes.map((s) => (s && s.code ? String(s.code) : '')).filter(Boolean);
      if (sizeCodes.length === 0) return;

      const materialMultipliers =
        pricing.material_multipliers && typeof pricing.material_multipliers === 'object' ? pricing.material_multipliers : {};
      const allowedMaterials = Array.isArray(config.materials) ? config.materials : [];
      const materialCodes = allowedMaterials.map((m) => (m && m.code ? String(m.code) : '')).filter(Boolean);
      const materialCode =
        materialCodes.length === 0
          ? 'pine'
          : materialCodes.reduce((best, code) => {
              const bestMult = Number.isFinite(Number(materialMultipliers[best])) ? Number(materialMultipliers[best]) : 1;
              const curMult = Number.isFinite(Number(materialMultipliers[code])) ? Number(materialMultipliers[code]) : 1;
              return curMult < bestMult ? code : best;
            }, materialCodes[0]);

      const finishMultipliers =
        pricing.finish_multipliers && typeof pricing.finish_multipliers === 'object' ? pricing.finish_multipliers : {};
      const finishCandidates = ['raw', 'stain', 'painted'];
      const finishTypeCode =
        finishCandidates.reduce((best, code) => {
          const bestMult = Number.isFinite(Number(finishMultipliers[best])) ? Number(finishMultipliers[best]) : 1;
          const curMult = Number.isFinite(Number(finishMultipliers[code])) ? Number(finishMultipliers[code]) : 1;
          return curMult < bestMult ? code : best;
        }, finishCandidates[0]) || 'raw';

      let min = null;
      sizeCodes.forEach((code) => {
        const dims = getSizeDimensionsMmForState(code, { sizeCode: code, customWidthMm: '', customHeightMm: '', customDepthMm: '' });
        if (!dims) return;
        const includedShelves = getIncludedShelves(dims.heightMm);
        const drawerRules = pricing.drawer_rules && typeof pricing.drawer_rules === 'object' ? pricing.drawer_rules : {};
        const includedDrawersRaw = drawerRules.included_drawers ?? drawerRules.base_included_drawers ?? 0;
        const includedDrawers = Number.isFinite(Number(includedDrawersRaw)) ? Number(includedDrawersRaw) : 0;
        const minDrawersRaw = drawerRules.min_drawers ?? 0;
        const minDrawers = Number.isFinite(Number(minDrawersRaw)) ? Number(minDrawersRaw) : 0;
        const startingDrawers = Math.max(includedDrawers, minDrawers);
        const state = {
          sizeCode: code,
          customWidthMm: '',
          customHeightMm: '',
          customDepthMm: '',
          materialCode,
          finishTypes: {},
          finishTypeCode,
          shelves: String(includedShelves),
          drawers: startingDrawers > 0 ? String(startingDrawers) : '',
          adjustableShelves: false,
          difficultyTier: String(config.difficultyTier || '1'),
          difficultyMultiplier: String(config.difficultyMultiplier || ''),
        };
        const est = calculateEstimatedPriceForState(state);
        if (!Number.isFinite(est)) return;
        if (min == null || est < min) min = est;
      });

      if (!Number.isFinite(min)) return;
      startingPriceEl.textContent = formatMoney(min);
    } catch {
      // ignore
    }
  };

  const formatMoney = (amount) => {
    if (!Number.isFinite(amount)) return '';
    const currency = config && config.currency ? String(config.currency) : '';
    try {
      if (currency) {
        if (currency.toUpperCase() === 'AUD') {
          return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            currencyDisplay: 'narrowSymbol',
          }).format(amount);
        }
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
      }
    } catch {
      // ignore
    }
    return `$${Number(amount).toFixed(2)}`;
  };

  const setupOptionScroller = (scrollerEl) => {
    if (!(scrollerEl instanceof HTMLElement)) return;
    const rail = scrollerEl.querySelector('[data-jr-option-tiles="size-standard"]');
    if (!(rail instanceof HTMLElement)) return;
    const prevBtn = scrollerEl.querySelector('[data-jr-scroll="prev"]');
    const nextBtn = scrollerEl.querySelector('[data-jr-scroll="next"]');

    const updateButtons = () => {
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const hasOverflow = maxScroll > 4;
      scrollerEl.dataset.jrScrollable = hasOverflow ? '1' : '0';

      if (prevBtn instanceof HTMLButtonElement) {
        prevBtn.disabled = !hasOverflow || rail.scrollLeft <= 4;
      }
      if (nextBtn instanceof HTMLButtonElement) {
        nextBtn.disabled = !hasOverflow || rail.scrollLeft >= maxScroll - 4;
      }
    };

    const scrollByAmount = (dir) => {
      const amount = Math.max(120, Math.round(rail.clientWidth * 0.85));
      try {
        rail.scrollBy({ left: dir * amount, behavior: 'smooth' });
      } catch {
        rail.scrollLeft += dir * amount;
      }
      window.setTimeout(updateButtons, 220);
    };

    if (prevBtn instanceof HTMLElement) prevBtn.addEventListener('click', () => scrollByAmount(-1));
    if (nextBtn instanceof HTMLElement) nextBtn.addEventListener('click', () => scrollByAmount(1));

    rail.addEventListener('scroll', () => updateButtons(), { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  };

  const updatePrimaryAddButtonLabel = (estimatedPrice) => {
    try {
      const primaryAddButton =
        productForm.querySelector('button[type="submit"][name="add"]') || productForm.querySelector('button[type="submit"]');
      if (!(primaryAddButton instanceof HTMLButtonElement)) return;

      const original =
        primaryAddButton.getAttribute('data-jr-original-label') ||
        primaryAddButton.textContent ||
        primaryAddButton.getAttribute('aria-label') ||
        'Add to cart';

      if (!primaryAddButton.hasAttribute('data-jr-original-label')) {
        primaryAddButton.setAttribute('data-jr-original-label', String(original).trim());
      }

      if (!Number.isFinite(estimatedPrice)) {
        const label = primaryAddButton.getAttribute('data-jr-original-label') || 'Add to cart';
        primaryAddButton.textContent = label;
        return;
      }

      primaryAddButton.textContent = `${(primaryAddButton.getAttribute('data-jr-original-label') || 'Add to cart').trim()} - ${formatMoney(
        estimatedPrice
      )}`;
    } catch {
      // ignore
    }
  };

  const renderEstimatedPrice = () => {
    const value = calculateEstimatedPrice();
    if (!Number.isFinite(value)) {
      if (stepperPriceEl instanceof HTMLElement) {
        stepperPriceEl.hidden = true;
        stepperPriceEl.style.removeProperty('transform');
      }
      if (stepperPriceValueEl instanceof HTMLElement) stepperPriceValueEl.textContent = '';
      if (stepperLeadTimeEl instanceof HTMLElement) stepperLeadTimeEl.textContent = '';
      updatePrimaryAddButtonLabel(Number.NaN);
      return;
    }

    if (stepperPriceEl instanceof HTMLElement) stepperPriceEl.hidden = false;
    if (stepperPriceValueEl instanceof HTMLElement) stepperPriceValueEl.textContent = formatMoney(value);

    updatePrimaryAddButtonLabel(value);
    try {
      const primaryAddButton =
        productForm.querySelector('button[type="submit"][name="add"]') || productForm.querySelector('button[type="submit"]');
      if (primaryAddButton instanceof HTMLElement) {
        primaryAddButton.textContent = String(primaryAddButton.textContent || '')
          .replace(/[^\x20-\x7E]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }
    } catch {
      // ignore
    }
    updateStepperPricePosition();
  };

  const renderStickyCta = () => {
    if (!stickyCtaEl || !(stickyCtaEl instanceof HTMLElement)) return;
    if (isQuickAdd) {
      stickyCtaEl.hidden = true;
      return;
    }
    const state = buildState();
    const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
    const constraintHit = getConstraintIssuesForState(state, pricing);
    const value = calculateEstimatedPrice();
    const hasPrice = Number.isFinite(value);

    if (constraintHit) {
      const issuesText = constraintHit.issues.map((i) => i.msg).slice(0, 2).join(' / ');
      if (stickySelectionEl instanceof HTMLElement) {
        stickySelectionEl.textContent = `Outside standard range. ${issuesText}`;
        stickySelectionEl.textContent = String(stickySelectionEl.textContent || '')
          .replace(/[^\x20-\x7E]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }
      if (stickyPriceEl instanceof HTMLElement) stickyPriceEl.textContent = '';
      if (stickyAddBtnPriceEl instanceof HTMLElement) stickyAddBtnPriceEl.textContent = '';
      if (stickyAddBtnLabelEl instanceof HTMLElement) stickyAddBtnLabelEl.textContent = 'Call us';
      else if (stickyAddBtn instanceof HTMLElement) stickyAddBtn.textContent = 'Call us';
      stickyCtaEl.dataset.jrMode = 'call';
      stickyCtaEl.hidden = false;
      try {
        document.body.classList.toggle('jr-has-sticky-cta', true);
      } catch {
        // ignore
      }
      return;
    }

    const selectionBits = [];
    if (state.sizeLabel) selectionBits.push(state.sizeLabel);
    if (state.materialLabel) selectionBits.push(state.materialLabel);
    const selectionText = selectionBits.filter(Boolean).slice(0, 2).join(' / ');

    if (stickySelectionEl instanceof HTMLElement) {
      stickySelectionEl.textContent = selectionText;
      stickySelectionEl.textContent = String(stickySelectionEl.textContent || '')
        .replace(/[^\x20-\x7E]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }
    const stickyPriceText = hasPrice ? formatMoney(value) : '';
    if (stickyPriceEl instanceof HTMLElement) stickyPriceEl.textContent = stickyPriceText;
    if (stickyAddBtnPriceEl instanceof HTMLElement) stickyAddBtnPriceEl.textContent = stickyPriceText;
    if (stickyAddBtnLabelEl instanceof HTMLElement) stickyAddBtnLabelEl.textContent = 'Add to cart';
    else if (stickyAddBtn instanceof HTMLElement) stickyAddBtn.textContent = 'Add to cart';
    delete stickyCtaEl.dataset.jrMode;

    stickyCtaEl.hidden = !hasPrice || !stickyAllowedByScroll;

    try {
      document.body.classList.toggle('jr-has-sticky-cta', !stickyCtaEl.hidden);
    } catch {
      // ignore
    }
  };

  const renderSplitNote = () => {
    const splitNoteEl = configuratorRoot.querySelector('[data-jr-config-split-note]');
    if (!(splitNoteEl instanceof HTMLElement)) return;

    try {
      const state = buildState();
      const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
      const dims = getSizeDimensionsMmForState(state.sizeCode, state);
      if (!pricing || !dims) {
        splitNoteEl.hidden = true;
        splitNoteEl.textContent = '';
        return;
      }

      const split = getModularSplitForWidth(dims.widthMm, pricing);
      if (!split || split.count <= 1) {
        splitNoteEl.hidden = true;
        splitNoteEl.textContent = '';
        return;
      }

      const unitWidths = Array.isArray(split.unitWidthsMm) ? split.unitWidthsMm : [];
      const rounded = unitWidths.map((w) => Math.round(Number(w) || 0)).filter((w) => Number.isFinite(w) && w > 0);

      const allSame = rounded.length > 0 && rounded.every((w) => w === rounded[0]);
      if (allSame) {
        splitNoteEl.textContent = `Built as ${split.count} units x ${rounded[0]}W`;
        splitNoteEl.hidden = false;
        return;
      }

      const shown = rounded.slice(0, 4).map((w) => `${w}W`).join(' + ');
      const suffix = rounded.length > 4 ? ` + ${rounded.length - 4} more` : '';
      splitNoteEl.textContent = `Built as ${split.count} units: ${shown}${suffix}`;
      splitNoteEl.hidden = false;
    } catch {
      splitNoteEl.hidden = true;
      splitNoteEl.textContent = '';
    }
  };

  const renderOversizeCall = () => {
    if (!(oversizeCallRow instanceof HTMLElement)) return;
    try {
      const state = buildState();
      const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
      const hit = getConstraintIssuesForState(state, pricing);
      oversizeCallRow.hidden = !hit;
      oversizeCallRow.dataset.jrConstraintKind = hit && hit.issues.some((i) => i.kind === 'oversize') ? 'oversize' : 'undersize';
      if (oversizeCallTextEl instanceof HTMLElement) {
        const issuesText = hit ? hit.issues.map((i) => i.msg).join(' / ') : '';
        oversizeCallTextEl.textContent = hit ? `This custom size needs a quick check. ${issuesText}` : '';
      }
    } catch {
      oversizeCallRow.hidden = true;
      if (oversizeCallTextEl instanceof HTMLElement) oversizeCallTextEl.textContent = '';
    }
  };

  const renderLeadTime = () => {
    const state = buildState();
    const lt = computeLeadTime(state);
    const text = (lt && lt.text ? String(lt.text) : '').trim();
    const note = (lt && lt.note ? String(lt.note) : '').trim();
    if (!text) {
      if (leadTimeEl && leadTimeEl instanceof HTMLElement) {
        leadTimeEl.hidden = true;
        leadTimeEl.textContent = '';
      }
      if (stepperLeadTimeEl instanceof HTMLElement) stepperLeadTimeEl.textContent = '';
      return;
    }
    if (leadTimeEl && leadTimeEl instanceof HTMLElement) {
      leadTimeEl.hidden = false;
      leadTimeEl.textContent = note ? `Estimated production: ${text} - ${note}` : `Estimated production: ${text}`;
    }
    if (stepperLeadTimeEl instanceof HTMLElement) {
      stepperLeadTimeEl.textContent = text;
    }
  };

  const syncProperties = () => {
    const state = buildState();
    const dims = getSizeDimensionsMm(state.sizeCode);
    const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
    const computeCbm = (widthMm, heightMm, depthMm) => {
      const w = Number(widthMm);
      const h = Number(heightMm);
      const d = Number(depthMm);
      if (!Number.isFinite(w) || !Number.isFinite(h) || !Number.isFinite(d)) return null;
      if (w <= 0 || h <= 0 || d <= 0) return null;
      const cbm = (w / 1000) * (h / 1000) * (d / 1000);
      return Number.isFinite(cbm) ? cbm : null;
    };

    if (isCustomSize(state) && dims) {
      setProperty('Size', `Custom (${Math.round(dims.widthMm)}W x ${Math.round(dims.heightMm)}H)`);
      setProperty('Width (mm)', Math.round(dims.widthMm));
      setProperty('Height (mm)', Math.round(dims.heightMm));
      setProperty('Depth (mm)', Math.round(dims.depthMm || 0));
    } else {
      setProperty('Size', state.sizeLabel);
      setProperty('Width (mm)', '');
      setProperty('Height (mm)', '');
      setProperty('Depth (mm)', '');
    }

    try {
      if (pricing && dims) {
        const split = getModularSplitForWidth(dims.widthMm, pricing);
        if (split && split.count > 1) {
          setProperty('_Carcass count', split.count);
          setProperty('_Unit width (mm)', Math.round(split.unitWidthMm));
          const widths = Array.isArray(split.unitWidthsMm) ? split.unitWidthsMm : [];
          const widthsText = widths
            .map((w) => Math.round(Number(w) || 0))
            .filter((w) => Number.isFinite(w) && w > 0)
            .join(', ');
          setProperty('_Unit widths (mm)', widthsText);
        } else {
          setProperty('_Carcass count', '');
          setProperty('_Unit width (mm)', '');
          setProperty('_Unit widths (mm)', '');
        }
      } else {
        setProperty('_Carcass count', '');
        setProperty('_Unit width (mm)', '');
        setProperty('_Unit widths (mm)', '');
      }
    } catch {
      setProperty('_Carcass count', '');
      setProperty('_Unit width (mm)', '');
      setProperty('_Unit widths (mm)', '');
    }
    setProperty('_Size code', state.sizeCode);
    setProperty('Material', state.materialLabel);
    setProperty('_Material code', state.materialCode);

    const isMultiSlotMode = config && config.colourSlotMode ? String(config.colourSlotMode) === 'multi' : false;
    const finishEntries = state.finishTypes && typeof state.finishTypes === 'object' ? Object.entries(state.finishTypes) : [];

    if (!isMultiSlotMode) {
      setProperty('Finish', state.finishTypeLabel);
      setProperty('_Finish type code', state.finishTypeCode);
      const baseFinish = state.finishTypes && typeof state.finishTypes === 'object' ? state.finishTypes.base : null;
      if (state.twoTone && baseFinish && typeof baseFinish === 'object' && baseFinish.code) {
        setProperty('Finish (Base)', String(baseFinish.label || ''));
        setProperty('_Finish type code (Base)', String(baseFinish.code || ''));
      } else {
        setProperty('Finish (Base)', '');
        setProperty('_Finish type code (Base)', '');
      }
    } else {
      finishEntries.forEach(([slot, value]) => {
        const slotKey = String(slot || 'main');
        const code = value && typeof value === 'object' ? String(value.code || '') : '';
        const label = value && typeof value === 'object' ? String(value.label || '') : '';

        if (slotKey === 'main') {
          setProperty('Finish', label);
          setProperty('_Finish type code', code);
          return;
        }

        const pretty = slotKey
          .replaceAll('_', ' ')
          .replaceAll('-', ' ')
          .replace(/\b\w/g, (m) => m.toUpperCase());
        setProperty(`Finish (${pretty})`, label);
        setProperty(`_Finish type code (${pretty})`, code);
      });
    }

    const colourEntries = state.colours && typeof state.colours === 'object' ? Object.entries(state.colours) : [];
    if (colourEntries.length === 0) {
      setProperty('Colour', '');
      setProperty('_Colour code', '');
    } else {
      colourEntries.forEach(([slot, value]) => {
        const slotKey = String(slot || 'main');
        const code = value && typeof value === 'object' ? String(value.code || '') : '';
        const label = value && typeof value === 'object' ? String(value.label || '') : '';

        if (slotKey === 'main') {
          setProperty('Colour', label);
          setProperty('_Colour code', code);
          return;
        }

        const pretty = slotKey
          .replaceAll('_', ' ')
          .replaceAll('-', ' ')
          .replace(/\b\w/g, (m) => m.toUpperCase());
        setProperty(`Colour (${pretty})`, label);
        setProperty(`_Colour code (${pretty})`, code);
      });
    }
    const selectedDepthMm = dims ? getSelectedDepthMm(state, dims) : null;
    const depthDisplay =
      isCustomSize(state) && selectedDepthMm ? `${Math.round(selectedDepthMm)}mm` : state.depthLabel || (selectedDepthMm ? `${Math.round(selectedDepthMm)}mm` : '');
    setProperty('Depth', depthDisplay);
    setProperty('_Depth code', state.depthCode);
    if (shelvesField) {
      const dimsShelves = dims ? getIncludedShelves(dims.heightMm) : null;
      const shelvesCount = Number.parseInt(state.shelves, 10);
      const shelvesSafe = Number.isFinite(shelvesCount) ? shelvesCount : dimsShelves || 0;
      setProperty('Shelves', shelvesSafe);
      if (dimsShelves != null) {
        setProperty('_Included shelves', dimsShelves);
        setProperty('_Charged extra shelves', Math.max(0, shelvesSafe - dimsShelves));
      } else {
        setProperty('_Included shelves', '');
        setProperty('_Charged extra shelves', '');
      }
    } else {
      setProperty('Shelves', '');
      setProperty('_Included shelves', '');
      setProperty('_Charged extra shelves', '');
    }

    if (drawersField) {
      const raw = Number.parseInt(String(state.drawers || ''), 10);
      const count = Number.isFinite(raw) && raw > 0 ? raw : 1;
      setProperty('Drawers', count);
      if (dims) {
        setProperty('_Recommended drawers', getRecommendedDrawers(dims.heightMm));
        setProperty('_Max drawers', getMaxDrawers(dims.heightMm));
      } else {
        setProperty('_Recommended drawers', '');
        setProperty('_Max drawers', '');
      }
    } else {
      setProperty('Drawers', '');
      setProperty('_Recommended drawers', '');
      setProperty('_Max drawers', '');
    }

    const adjustableInputs = getAdjustableShelvesInputs();
    if (adjustableInputs.length > 0) setProperty('Adjustable shelves', state.adjustableShelves ? 'Yes' : 'No');
    else setProperty('Adjustable shelves', '');
    setProperty('Custom notes', state.notes);

    const leadTime = computeLeadTime(state);
    const leadTimeText = leadTime && leadTime.text ? String(leadTime.text) : '';
    const leadTimeNote = leadTime && leadTime.note ? String(leadTime.note) : '';
    setProperty('Production time', leadTimeNote && leadTimeText ? `${leadTimeText} (${leadTimeNote})` : leadTimeText || leadTimeNote);

    setProperty('_Difficulty tier', state.difficultyTier);
    setProperty('_Difficulty multiplier', state.difficultyMultiplier);

    const includedShelves = dims ? getIncludedShelves(dims.heightMm) : null;
    const estimatedPrice = calculateEstimatedPrice();
    const estimatedUnitPriceCents = Number.isFinite(estimatedPrice) ? Math.round(Number(estimatedPrice) * 100) : '';
    setProperty('_jr_est_unit_price_cents', estimatedUnitPriceCents);

    const cbm = dims && selectedDepthMm != null ? computeCbm(dims.widthMm, dims.heightMm, selectedDepthMm) : null;
    setProperty('cbm', cbm == null ? '' : cbm.toFixed(4));

    setProperty(
      '_Config JSON',
      JSON.stringify({
        ...state,
        dimsMm: dims
          ? {
              widthMm: dims.widthMm,
              heightMm: dims.heightMm,
              depthMm: selectedDepthMm,
            }
          : null,
        modularSplit: pricing && dims ? getModularSplitForWidth(dims.widthMm, pricing) : null,
        includedShelves,
        cbm: cbm == null ? null : Number(cbm.toFixed(4)),
        estimatedPrice,
        leadTime: leadTime && leadTime.text ? String(leadTime.text) : '',
        leadTimeNote: leadTime && leadTime.note ? String(leadTime.note) : '',
        currency: config.currency,
        productId: config.productId,
        variantId: config.variantId,
      })
    );
  };

  const renderErrors = (errors) => {
    if (!errorsEl) return;
    if (!errors || errors.length === 0) {
      errorsEl.hidden = true;
      errorsEl.innerHTML = '';
      return;
    }
    errorsEl.hidden = false;
    errorsEl.innerHTML = `<ul>${errors
      .map((e) =>
        `<li>${escapeHtml(
          String(e || '')
            .replace(/[^\x20-\x7E]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
        )}</li>`
      )
      .join('')}</ul>`;
  };

  const validate = () => {
    const errors = [];
    const state = buildState();
    if (sizeField && !sizeField.value) errors.push('Please select a size.');
    if (sizeField && sizeField.value === '__custom__') {
      const widthMm = Number(state.customWidthMm);
      const heightMm = Number(state.customHeightMm);
      const depthMm = Number(state.customDepthMm);
      if (!Number.isFinite(widthMm) || widthMm <= 0) errors.push('Please enter a custom width (mm).');
      if (!Number.isFinite(heightMm) || heightMm <= 0) errors.push('Please enter a custom height (mm).');
      if (!Number.isFinite(depthMm) || depthMm <= 0) errors.push('Please enter a custom depth (mm).');

      const pricing = config && typeof config.pricing === 'object' && config.pricing ? config.pricing : null;
      const constraints = getCustomConstraints(pricing);
      if (constraints) {
        if (Number.isFinite(widthMm) && widthMm > 0) {
          if (Number.isFinite(constraints.minWidthMm) && widthMm < constraints.minWidthMm) {
            errors.push(`Custom width must be at least ${constraints.minWidthMm}mm.`);
          }
          if (Number.isFinite(constraints.maxWidthMm) && widthMm > constraints.maxWidthMm) {
            errors.push(`Custom width must be ${constraints.maxWidthMm}mm or less.`);
          }
        }
        if (Number.isFinite(heightMm) && heightMm > 0) {
          if (Number.isFinite(constraints.minHeightMm) && heightMm < constraints.minHeightMm) {
            errors.push(`Custom height must be at least ${constraints.minHeightMm}mm.`);
          }
          if (Number.isFinite(constraints.maxHeightMm) && heightMm > constraints.maxHeightMm) {
            errors.push(`Custom height must be ${constraints.maxHeightMm}mm or less.`);
          }
        }
        if (Number.isFinite(depthMm) && depthMm > 0) {
          if (Number.isFinite(constraints.minDepthMm) && depthMm < constraints.minDepthMm) {
            errors.push(`Custom depth must be at least ${constraints.minDepthMm}mm.`);
          }
          if (Number.isFinite(constraints.maxDepthMm) && depthMm > constraints.maxDepthMm) {
            errors.push(`Custom depth must be ${constraints.maxDepthMm}mm or less.`);
          }
        }
      }
    }
    if (materialField && !materialField.value) errors.push('Please select a material.');

    const finishesBySlot = state.finishTypes && typeof state.finishTypes === 'object' ? state.finishTypes : {};
    const hasPerSlotFinishes =
      (config && config.colourSlotMode ? String(config.colourSlotMode) === 'multi' : false) && Object.keys(finishesBySlot).length > 0;
    if (hasPerSlotFinishes) {
      const missingFinish = Object.values(finishesBySlot).some((v) => !v || !v.code);
      if (missingFinish) errors.push('Please select a finish.');
    } else {
      if (finishTypeField && !finishTypeField.value) errors.push('Please select a finish.');
      if (state.twoTone) {
        const baseFinish = finishesBySlot.base && typeof finishesBySlot.base === 'object' ? String(finishesBySlot.base.code || '') : '';
        if (!baseFinish) errors.push('Please select a base finish (or choose \"No\" for two-tone).');
      }
    }

    const colourSelects = getColourSelects();
    if (colourSelects.length > 0) {
      const missingColour = colourSelects.some((s) => {
        if (!(s instanceof HTMLSelectElement)) return false;
        const slot = String(s.dataset.jrConfigColourSlot || 'main');
        const finishTypeCode = hasPerSlotFinishes
          ? String((finishesBySlot[slot] && finishesBySlot[slot].code) || '')
          : String(getFinishCodeForSlot(state, slot) || '');
        if (!finishTypeCode || finishTypeCode === 'raw') return false;
        return !s.value;
      });
      if (missingColour) errors.push('Please select a colour.');
    }

    if (drawersField && String(state.drawers || '').trim() !== '') {
      const raw = Number.parseInt(String(state.drawers || ''), 10);
      const count = Number.isFinite(raw) ? raw : 1;
      if (!Number.isFinite(raw) || count < 1) errors.push('Drawers must be 1 or greater.');
      const dims = getSizeDimensionsMmForState(state.sizeCode, state);
      if (dims) {
        const max = getMaxDrawers(dims.heightMm);
        if (count > max) errors.push(`Drawers max is ${max} for this height.`);
      }
    }
    if (shelvesField && shelvesField.value !== '') {
      const count = Number.parseInt(shelvesField.value, 10);
      if (!Number.isFinite(count) || count < 0) errors.push('Shelves must be 0 or greater.');
      const dims = getSizeDimensionsMm(state.sizeCode);
      if (dims) {
        const max = getMaxShelves(dims.heightMm);
        const included = getIncludedShelves(dims.heightMm);
        if (count > max) errors.push(`Shelves max is ${max} for this height.`);
        if (count < included) errors.push(`Shelves must be at least ${included} for this height.`);
      }
    }
    return errors;
  };

  const setupNumberStepper = () => {
    const setupFor = (key, inputEl) => {
      if (!(inputEl instanceof HTMLInputElement)) return;
      const wrapper = inputEl.closest(`[data-jr-number-stepper="${escapeAttrValue(key)}"]`);
      if (!(wrapper instanceof HTMLElement)) return;
      if (wrapper.hasAttribute('data-jr-init')) return;
      wrapper.setAttribute('data-jr-init', '1');

      const clamp = (n) => {
        let value = n;
        const min = inputEl.min !== '' ? Number(inputEl.min) : null;
        const max = inputEl.max !== '' ? Number(inputEl.max) : null;
        if (min != null && Number.isFinite(min)) value = Math.max(min, value);
        if (max != null && Number.isFinite(max)) value = Math.min(max, value);
        return value;
      };

      wrapper.addEventListener('click', (ev) => {
        const target = ev.target instanceof HTMLElement ? ev.target.closest('[data-jr-stepper-btn]') : null;
        if (!target) return;
        const dir = target.getAttribute('data-jr-stepper-btn') === 'dec' ? -1 : 1;
        const current = Number.parseInt(String(inputEl.value || '0'), 10);
        const next = clamp((Number.isFinite(current) ? current : 0) + dir);
        inputEl.value = String(next);
        inputEl.dispatchEvent(new Event('input', { bubbles: true }));
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    setupFor('drawers', drawersField);
    setupFor('shelves', shelvesField);
  };

  const handleConfiguratorChange = (event) => {
    if (event && !(event.target instanceof HTMLElement)) return;
    if (event && !event.target.closest('[data-jr-config-field], [data-jr-config-colour-slot], [data-jr-config-finish-slot]')) return;
    syncCustomSizeFields();
    syncDrawerRules();
    syncTwoToneVisibility();
    syncFinishAvailability();
    syncColourField();
    syncShelfRules();
    syncProperties();
    renderErrors([]);
    renderSplitNote();
    renderEstimatedPrice();
    renderLeadTime();
    renderOptionTiles();
    renderStickyCta();
    renderOversizeCall();
    updateStepSummaries();
    updateStepperPricePosition();
    if (event && event.target instanceof HTMLElement) advanceFromTarget(event.target);
  };

    configuratorRoot.addEventListener('change', handleConfiguratorChange);
    configuratorRoot.addEventListener('input', handleConfiguratorChange);
    configuratorRoot.addEventListener('click', (ev) => {
      const target = ev.target instanceof HTMLElement ? ev.target.closest('[data-jr-step-help]') : null;
      if (!(target instanceof HTMLElement)) return;
      ev.preventDefault();
      ev.stopPropagation();
      ev.stopImmediatePropagation();
      const key = String(target.getAttribute('data-jr-step-help') || '').trim();
      if (key === 'finish') {
        openDialog(FINISH_STEP_HELP.title, FINISH_STEP_HELP.body);
      }
    });
    configuratorRoot.addEventListener('click', (ev) => {
      const target = ev.target instanceof HTMLElement ? ev.target : null;
      if (!target) return;
      const label = target.closest('label.jr-toggle__option');
      const input =
        (label
          ? label.querySelector('input[data-jr-config-field="twoTone"], input[data-jr-config-field="adjustableShelves"]')
          : null) ||
        target.closest('input[data-jr-config-field="twoTone"], input[data-jr-config-field="adjustableShelves"]');
      if (!(input instanceof HTMLInputElement)) return;
      setTimeout(() => advanceFromTarget(input), 0);
    });

    if (stickyAddBtn instanceof HTMLElement) {
      stickyAddBtn.addEventListener('click', () => {
        try {
          if (stickyCtaEl instanceof HTMLElement && stickyCtaEl.dataset.jrMode === 'call') {
            window.location.href = 'tel:0265946521';
            return;
          }
          const submitBtn =
            productForm.querySelector('button[type="submit"][name="add"]') || productForm.querySelector('button[type="submit"]');
          if (submitBtn instanceof HTMLElement) {
            submitBtn.click();
          } else if (typeof productForm.requestSubmit === 'function') {
            productForm.requestSubmit();
          } else {
            productForm.submit();
          }
        } catch {
          // ignore
        }
      });
    }

    // Show sticky CTA after the user has scrolled ~20% down the page (Koala-style).
    try {
      if (!isQuickAdd) {
        const onScrollProgress = () => {
          const doc = document.documentElement;
          const scrollTop = window.pageYOffset || doc.scrollTop || 0;
          const scrollable = Math.max(1, (doc.scrollHeight || 0) - window.innerHeight);
          const progress = scrollTop / scrollable;
          stickyAllowedByScroll = progress >= 0.2;
          renderStickyCta();
        };
        window.addEventListener('scroll', onScrollProgress, { passive: true });
        window.addEventListener('resize', onScrollProgress);
        onScrollProgress();
      }
    } catch {
      // ignore
    }

    productForm.addEventListener('submit', (event) => {
      syncFinishAvailability();
      syncColourField();
      syncCustomSizeFields();
      syncDrawerRules();
      syncShelfRules();
      renderLeadTime();
      const errors = validate();
      if (errors.length > 0) {
        event.preventDefault();
        renderErrors(errors);
        if (errorsEl) errorsEl.scrollIntoView({ block: 'center' });
        return;
      }
      syncProperties();
    });

    syncCustomSizeFields();
    syncDrawerRules();
    syncTwoToneVisibility();
    syncFinishAvailability();
    syncColourField();
    syncShelfRules();
    setupNumberStepper();
    syncProperties();
    renderSplitNote();
    renderEstimatedPrice();
    renderLeadTime();
    renderOptionTiles();
    renderStickyCta();
    renderOversizeCall();
    updateStepSummaries();
    renderStartingFromPrice();

    // Size scroller arrows.
    try {
      const scroller = configuratorRoot.querySelector('[data-jr-option-scroller="size"]');
      if (scroller) setupOptionScroller(scroller);
    } catch {
      // ignore
    }

    // Accordion behavior: one open at a time.
    if (stepsContainer instanceof HTMLElement) {
      stepsContainer.addEventListener('toggle', (ev) => {
        if (!(ev.target instanceof HTMLDetailsElement)) return;
        if (!ev.target.open) return;
        closeOtherSteps(ev.target);
        updateStepperPricePosition();
      });
    }

    openFirstIncompleteStep();
    updateStepperPricePosition();

    window.addEventListener('resize', updateStepperPricePosition);
  } catch (e) {
    // Fail open with an on-page message so debugging doesn't require DevTools.
    const errorsEl = configuratorRoot.querySelector('[data-jr-configurator-errors]');
    if (errorsEl) {
      errorsEl.hidden = false;
      const message = e instanceof Error ? e.message : String(e);
      errorsEl.innerHTML = `<p><strong>Configurator error:</strong> <code>${message.replaceAll('<', '&lt;').replaceAll('>', '&gt;')}</code></p>`;
    }
    // Also log to console for dev.
    // eslint-disable-next-line no-console
    console.error('Configurator error', e);
  }
  };

  const scan = (root = document) => {
    root.querySelectorAll?.('[data-jr-configurator]').forEach(initConfigurator);
  };

  scan();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.('[data-jr-configurator]')) initConfigurator(node);
        scan(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
